const languageTranslation = {
  'en-GB': {
    reservation: {
      new_reservation: 'New Reservation',
      packages: 'Packages',
      accommodation: 'Accommodation',
      fishing: 'Fishing',
      Taxi: 'Taxi',
      add_ons: 'Add-Ons',
      guest_details: 'Guest Details',
      packagePrice: 'Package Price',
      viewPackage: 'View Package',
      bookNow: 'Book Now',
      check_availabilty_book: 'Check availabilty & book now',
      add_reservation_based_on_package:
        'Add reservation based on a preset package?',
      yes: 'Yes',
      no: 'No',
      select_package_heading: 'Please select from the available packages:',
      no_image: 'No Image',
      last_minute: 'LAST MINUTE',
      early_bird: 'EARLY BIRD',
      unlimited: 'UNLIMITED',
      date_range: 'DATE RANGE',
      save_continue: 'Save & Continue',
      balancePaid: 'Balance to be paid prior to stay',
      underStandPrice: 'I understand that the price will be',
      priceQuotedHere:
        'and the price quoted here is an approximation based on global currency exchange rates.',
      finalPriceConfirmation: 'Final Price Confirmation',
      accommodationQuestion: 'Does the reservation include an overnight stay?',
      edit: 'EDIT',
      step: 'Step',
      complete: 'Complete',
      numberOfGuests: 'No. Of Guests:',
      adults: 'Adult',
      children: 'Child',
      teen: 'Teen',
      numberOfRooms: 'No. Of Rooms:',
      accommodationAvailabilityReminder:
        'PLEASE COMPLETE THE NO. OF GUESTS AND ROOMS REQUIRED TO SEE AVAILABILITY',
      checkIn: 'Check-in',
      checkInPrefix: 'is from',
      checkInSuffix: 'on day of arrival',
      checkOut: 'Check-out',
      checkOutPrefix: 'is by',
      checkOutSuffix: 'on day of departure',
      saveAndContinue: 'Save & Continue',
      clearSelection: 'Clear Selection',
      pleaseSeeYour: 'Please see your',
      quoteBelow: 'Quote Below',
      fishingQuestion: 'Does this reservation include fishing?',
      selectYourLake: 'Select your lake',
      noOfAnglers: 'No. Of Anglers:',
      noOfSwims: 'No. Of Swims:',
      noOfGuest: 'Non-Angling Guests:',
      noOfFishingDays: 'No. Of Fishing Days:',
      completeAnglersSwimsDays:
        'Please complete the no. of anglers, swims and fishing days to see availability',
      selectYourFishingDates: 'Select Your Fishing Dates:',
      mainLakeTitle: 'The Main Lake',
      mainLakeDescription:
        'More than a hundred of the fish in this lake are in excess of the 200lb mark, including a number of record-size specimens up to 200lb, ensuring that even the most die-hard of Specimen Hunters has a long list of targets to consider during each and every visit to us, which is why so many of our anglers return year on year.',
      mainLakeAlt: 'Main Lake',
      EFTKnowTitle: 'Things to know about fishing at EFT',
      EFTKnowDescription:
        'The Main Lake is predominantly for guests staying at the resort, while the arapaima lake has been setup for day ticket trips. Anglers travelling through Thailand that want an unforgettable experience targeting Arapaima should seriously consider this lake!',
      arapaimaLakeDescription1:
        ' Our Day Trip Lake is designed and stocked for fishermen who do not have the time to spend their holiday fishing due to other commitments but they do want to catch an Arapaima!',
      arapaimaLakeDescription2:
        'We have created a lake that can cater for large groups of customers by introducing a large number of Arapaima.',
      taxiQuestion: 'Does this reservation include taxi’s / transfers?',
      addOnsQuestion: 'Does this reservation include add-ons?',
      taxi: {
        addPickupTaxi: 'Add Pickup Taxi:',
        pickupDateTime: 'Pickup Date & Time:',
        pickupLocation: 'Pickup Location:',
        addDropoffTaxi: 'Add Dropoff Taxi:',
        dropoffDateTime: 'Dropoff Date & Time:',
        dropoffLocation: 'Dropoff Location:',
        selectTime: 'Select time',
        infoNotAvailableTitle: 'I don’t have this information yet',
        infoNotAvailableNote: '(Don’t worry, it can be added later!)',
        saveAndContinue: 'Save & Continue',
        yes: 'Yes',
        no: 'No',
      },
      cancel: 'Cancel',
      proceedToPayment: 'Proceed to Payment',
      leadGuest: {
        title: 'Lead Guest Details',
        guestTitle: 'Title',
        selectTitle: 'Select Title',
        mr: 'Mr',
        mrs: 'Mrs',
        miss: 'Miss',
        ms: 'Ms',
        dr: 'Dr',
        nationality: 'Nationality',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phoneNumber: 'Phone Number',
        additionalInformation: 'Additional Information',
        declaration:
          'I confirm that I have read and understood the terms and conditions of booking and that all info provided is true and accurate.',
        save: 'Save',
      },
    },
    quote_summary: {
      quote_summary: 'Quote Summary',
      deposit_perc: 'Deposit',
      summary: 'Summary',
      viewSummary: 'View Summary',
      accommodation_included: 'Accommodation Included',
      no_of_adults: 'No. Of Adults',
      no_of_children: 'No. Of Children',
      no_of_teens: 'No. Of Teens',
      no_of_rooms: 'No. Of Rooms',
      arrival_date: 'Arrival Date',
      departure_date: 'Departure Date',
      fishing_included: 'Fishing Included',
      no_of_anglers: 'No. Of Anglers',
      no_of_swims: 'No. Of Swims',
      no_of_fishing_days: 'No. Of Fishing Days',
      fishing_dates: 'Fishing Dates',
      taxis_included: "Taxi's Included",
      pick_up_date_and_time: 'Pickup Date And Time',
      pick_up_location: 'Pickup Location',
      drop_off_date_and_time: 'Dropoff Date And Time',
      drop_off_location: 'Dropoff Location',
      add_ons: 'Add-ons',
      total_price: 'Total Price',
      pay_today: 'Pay Today',
      your_quote: 'your quote',
      safe_checkout: 'VERIFIED SAFE CHECKOUT',
      accept_quote: 'ACCEPT QUOTE & BOOK NOW',
      holidayInfoNote:
        'For a comprehensive breakdown of everything included in your quote, please check out our holiday information pack',
      conversion_note:
        ' Please note currency will be converted to GBP at checkout',
      quote_expired: 'Your quote has expired. Please contact reservations.',
      availability_note:
        'Please note that quotes are subject to live availability at the time of checkout. Please pay and secure your booking as soon as possible to avoid your requested dates becoming unavailable.',
      default_description:
        "Thank you for showing interest in booking Exotic Fishing Thailand! We can't wait to welcome you to the resort. Please verify your quote details on the 'Quote Summary' section and when ready to proceed, please click 'Accept Quote & Book Now'. Any questions? Please contact ",
    },
  },
  ms: {
    reservation: {
      new_reservation: 'Tempahan Baru',
      packages: 'Pakej',
      accommodation: 'Penginapan',
      fishing: 'Memancing',
      Taxi: 'Teksi',
      add_ons: 'Tambahan',
      guest_details: 'Maklumat Tetamu',
      clearSelection: 'Kosongkan Pilihan',
      pleaseSeeYour: 'Sila lihat',
      quoteBelow: 'Sebutharga di bawah',
      packagePrice: 'Harga Pakej',
      viewPackage: 'Lihat Pakej',
      bookNow: 'Tempah Sekarang',
      check_availabilty_book: 'Semak ketersediaan & tempah sekarang',

      balancePaid: 'Baki perlu dibayar sebelum penginapan',
      underStandPrice: 'Saya faham bahawa harga akan menjadi',
      priceQuotedHere:
        'dan harga yang dinyatakan di sini adalah anggaran berdasarkan kadar pertukaran mata wang global.',
      finalPriceConfirmation: 'Pengesahan Harga Akhir',

      add_reservation_based_on_package:
        'Tambah tempahan berdasarkan pakej yang telah ditetapkan?',
      yes: 'Ya',
      no: 'Tidak',
      select_package_heading: 'Sila pilih dari pakej yang tersedia:',
      no_image: 'Tiada Imej',
      last_minute: 'MINIT TERAKHIR',
      early_bird: 'AWAL',
      unlimited: 'TIDAK TERHAD',
      date_range: 'JANGKA MASA',
      save_continue: 'Simpan & Teruskan',

      accommodationQuestion: 'Adakah tempahan termasuk penginapan semalaman?',
      edit: 'SUNGAH',
      step: 'Langkah',
      complete: 'Lengkap',
      numberOfGuests: 'Bilangan Tetamu:',
      adults: 'Dewasa',
      children: 'Kanak-kanak',
      teen: 'Remaja',
      numberOfRooms: 'Bilangan Bilik:',
      accommodationAvailabilityReminder:
        'SILA ISI BILANGAN TETAMU DAN BILIK UNTUK MELIHAT KEMUDAHAN',
      checkIn: 'Daftar masuk',
      checkInPrefix: 'adalah dari',
      checkInSuffix: 'pada hari ketibaan',
      checkOut: 'Daftar keluar',
      checkOutPrefix: 'adalah sebelum',
      checkOutSuffix: 'pada hari berlepas',
      saveAndContinue: 'Simpan & Teruskan',

      fishingQuestion: 'Adakah tempahan ini termasuk memancing?',
      selectYourLake: 'Pilih tasik anda',
      noOfAnglers: 'Bilangan Pemancing:',
      noOfSwims: 'Bilangan tempat memancing:',
      noOfGuest: 'Tetamu Bukan Pemancing:',
      noOfFishingDays: 'Bilangan hari memancing:',
      completeAnglersSwimsDays:
        'Sila lengkapkan bilangan pemancing, tempat memancing dan hari memancing untuk melihat kemudahan',
      selectYourFishingDates: 'Pilih Tarikh Memancing Anda:',
      mainLakeTitle: 'Tasik Utama',
      mainLakeDescription:
        'Lebih daripada seratus ikan di tasik ini melebihi berat 200lb, termasuk beberapa spesimen rekod sehingga 200lb, memastikan setiap pemancing mempunyai banyak sasaran untuk setiap lawatan, sebab itulah ramai pemancing kami kembali setiap tahun.',
      mainLakeAlt: 'Tasik Utama',
      EFTKnowTitle: 'Perkara yang perlu diketahui mengenai memancing di EFT',
      EFTKnowDescription:
        'Tasik Utama kebanyakannya untuk tetamu yang menginap di resort, manakala tasik arapaima disediakan untuk perjalanan tiket harian. Pemancing yang melalui Thailand yang mahu pengalaman memancing Arapaima patut mempertimbangkan tasik ini!',
      arapaimaLakeDescription1:
        'Tasik Trip Harian kami direka dan diisi untuk pemancing yang tiada masa memancing sepanjang cuti tetapi mahu memancing Arapaima!',
      arapaimaLakeDescription2:
        'Kami telah mewujudkan tasik yang boleh menampung kumpulan besar dengan memperkenalkan banyak Arapaima.',
      taxiQuestion: 'Adakah tempahan ini termasuk teksi / pengangkutan?',
      addOnsQuestion: 'Adakah tempahan ini termasuk tambahan?',
      taxi: {
        addPickupTaxi: 'Tambah Teksi Pengambilan:',
        pickupDateTime: 'Tarikh & Masa Pengambilan:',
        pickupLocation: 'Lokasi Pengambilan:',
        addDropoffTaxi: 'Tambah Teksi Hantaran:',
        dropoffDateTime: 'Tarikh & Masa Hantaran:',
        dropoffLocation: 'Lokasi Hantaran:',
        selectTime: 'Pilih masa',
        infoNotAvailableTitle: 'Saya belum ada maklumat ini',
        infoNotAvailableNote: '(Jangan risau, boleh ditambah kemudian!)',
        saveAndContinue: 'Simpan & Teruskan',
        yes: 'Ya',
        no: 'Tidak',
      },
      cancel: 'Batal',
      proceedToPayment: 'Teruskan ke Pembayaran',
      leadGuest: {
        title: 'Maklumat Tetamu Utama',
        guestTitle: 'Gelaran',
        selectTitle: 'Pilih Gelaran',
        mr: 'Encik',
        mrs: 'Puan',
        miss: 'Cik',
        ms: 'Cik',
        dr: 'Dr',
        nationality: 'Warganegara',
        firstName: 'Nama Pertama',
        lastName: 'Nama Akhir',
        email: 'Emel',
        phoneNumber: 'Nombor Telefon',
        additionalInformation: 'Maklumat Tambahan',
        declaration:
          'Saya mengesahkan bahawa saya telah membaca dan memahami terma dan syarat tempahan dan semua maklumat yang diberikan adalah benar dan tepat.',
        save: 'Simpan',
      },
    },
    quote_summary: {
      quote_summary: 'Ringkasan Sebutharga',
      deposit_perc: 'Deposit',
      summary: 'Ringkasan',
      viewSummary: 'Lihat Ringkasan',
      accommodation_included: 'Penginapan Termasuk',
      no_of_adults: 'Bilangan Dewasa',
      no_of_children: 'Bilangan Kanak-kanak',
      no_of_teens: 'Bilangan Remaja',
      no_of_rooms: 'Bilangan Bilik',
      arrival_date: 'Tarikh Ketibaan',
      departure_date: 'Tarikh Berlepas',
      fishing_included: 'Memancing Termasuk',
      no_of_anglers: 'Bilangan Pemancing',
      no_of_swims: 'Bilangan Tempat Memancing',
      no_of_fishing_days: 'Bilangan Hari Memancing',
      fishing_dates: 'Tarikh Memancing',
      taxis_included: 'Teksi Termasuk',
      pick_up_date_and_time: 'Tarikh dan Masa Pengambilan',
      pick_up_location: 'Lokasi Pengambilan',
      drop_off_date_and_time: 'Tarikh dan Masa Hantaran',
      drop_off_location: 'Lokasi Hantaran',
      add_ons: 'Tambahan',
      total_price: 'Jumlah Harga',
      pay_today: 'Bayar Hari Ini',
      your_quote: 'Sebutharga anda',
      safe_checkout: 'PEMBAYARAN SELAMAT TERPERCAYA',
      accept_quote: 'TERIMA SEBUTHARGA & TEMPAH SEKARANG',
      holidayInfoNote:
        'Untuk pecahan lengkap segala yang termasuk dalam sebut harga anda, sila semak pek maklumat percutian kami di',
      conversion_note:
        ' Sila ambil perhatian bahawa mata wang akan ditukar kepada GBP semasa pembayaran',
      quote_expired:
        'Sebutharga anda telah tamat tempoh. Sila hubungi bahagian tempahan.',
      availability_note:
        'Sila ambil perhatian sebutharga tertakluk kepada ketersediaan masa nyata semasa pembayaran. Sila bayar dan pastikan tempahan anda secepat mungkin untuk mengelakkan tarikh yang diminta menjadi tidak tersedia.',
      default_description:
        "Terima kasih kerana berminat untuk menempah Exotic Fishing Thailand! Kami tidak sabar untuk mengalu-alukan kedatangan anda ke resort. Sila semak butiran sebut harga anda di bahagian 'Ringkasan Sebut Harga' dan apabila bersedia, klik 'Terima Sebut Harga & Tempah Sekarang'. Ada soalan? Sila hubungi ",
    },
  },

  cs: {
    reservation: {
      new_reservation: 'Nová rezervace',
      packages: 'Balíčky',
      accommodation: 'Ubytování',
      fishing: 'Rybaření',
      Taxi: 'Taxi',
      add_ons: 'Doplňky',
      guest_details: 'Detaily hosta',
      clearSelection: 'Zrušit výběr',
      pleaseSeeYour: 'Prosím, podívejte se na své',
      quoteBelow: 'Cenová nabídka níže',
      packagePrice: 'Cena balíčku',
      viewPackage: 'Zobrazit balíček',
      bookNow: 'Rezervovat nyní',
      check_availabilty_book: 'Zkontrolujte dostupnost a rezervujte nyní',
      add_reservation_based_on_package:
        'Přidat rezervaci na základě přednastaveného balíčku?',
      yes: 'Ano',
      no: 'Ne',
      select_package_heading: 'Vyberte prosím z dostupných balíčků:',
      no_image: 'Žádný obrázek',
      last_minute: 'NA POSLEDNÍ CHVÍLI',
      early_bird: 'RANNÍ PTÁČE',
      unlimited: 'NEOMEZENÝ',
      date_range: 'ČASOVÉ OBDOBÍ',
      save_continue: 'Uložit a pokračovat',
      balancePaid: 'Zůstatek musí být zaplacen před pobytem',
      underStandPrice: 'Rozumím, že cena bude',
      priceQuotedHere:
        'a cena uvedená zde je přibližná podle globálních směnných kurzů.',
      finalPriceConfirmation: 'Potvrzení konečné ceny',
      accommodationQuestion: 'Zahrnuje rezervace přenocování?',
      edit: 'UPRAVIT',
      step: 'Krok',
      complete: 'Dokončeno',
      numberOfGuests: 'Počet hostů:',
      adults: 'Dospělý',
      children: 'Dítě',
      teen: 'Teenager',
      numberOfRooms: 'Počet pokojů:',
      accommodationAvailabilityReminder:
        'PROSÍM DOKONČETE POČET HOSTŮ A POKOJŮ PRO ZOBRAZENÍ DOSTUPNOSTI',
      checkIn: 'Příjezd',
      checkInPrefix: 'je od',
      checkInSuffix: 'v den příjezdu',
      checkOut: 'Odjezd',
      checkOutPrefix: 'je do',
      checkOutSuffix: 'v den odjezdu',
      saveAndContinue: 'Uložit a pokračovat',

      fishingQuestion: 'Zahrnuje tato rezervace rybaření?',
      selectYourLake: 'Vyberte své jezero',
      noOfAnglers: 'Počet rybářů:',
      noOfSwims: 'Počet lovišť:',
      noOfGuest: 'Hosté, kteří neloví:',
      noOfFishingDays: 'Počet rybářských dnů:',
      completeAnglersSwimsDays:
        'Dokončete prosím počet rybářů, lovišť a rybářských dnů pro zobrazení dostupnosti',
      selectYourFishingDates: 'Vyberte své rybářské dny:',
      mainLakeTitle: 'Hlavní jezero',
      mainLakeDescription:
        'Ve více než stovce ryb v tomto jezeře přesahuje váha 200lb, včetně několika rekordních kusů až do 200lb, což zajišťuje, že i ti nejzapálenější lovci mají dlouhý seznam cílů při každé návštěvě, a proto se k nám spousta rybářů vrací každý rok.',
      mainLakeAlt: 'Hlavní jezero',
      EFTKnowTitle: 'Co byste měli vědět o rybaření na EFT',
      EFTKnowDescription:
        'Hlavní jezero je primárně pro hosty, kteří zůstávají v resortu, zatímco arapaima jezero je určeno pro denní výlety. Rybáři procházející Thajskem, kteří chtějí zažít Arapaima, by měli zvážit toto jezero!',
      arapaimaLakeDescription1:
        'Naše denní jezero je navrženo a naplněno pro rybáře, kteří nemají čas rybařit během dovolené, ale chtějí chytit Arapaimu!',
      arapaimaLakeDescription2:
        'Vytvořili jsme jezero, které může pojmout velké skupiny tím, že přidáváme spoustu Arapaima.',
      taxiQuestion: 'Zahrnuje tato rezervace taxi / dopravu?',
      addOnsQuestion: 'Zahrnuje tato rezervace doplňky?',
      taxi: {
        addPickupTaxi: 'Přidat taxi pro vyzvednutí:',
        pickupDateTime: 'Datum a čas vyzvednutí:',
        pickupLocation: 'Místo vyzvednutí:',
        addDropoffTaxi: 'Přidat taxi pro odvoz:',
        dropoffDateTime: 'Datum a čas odvozu:',
        dropoffLocation: 'Místo odvozu:',
        selectTime: 'Vyberte čas',
        infoNotAvailableTitle: 'Ještě nemám tyto informace',
        infoNotAvailableNote: '(Nebojte se, lze přidat později!)',
        saveAndContinue: 'Uložit a pokračovat',
        yes: 'Ano',
        no: 'Ne',
      },
      cancel: 'Zrušit',
      proceedToPayment: 'Pokračovat k platbě',
      leadGuest: {
        title: 'Detaily hlavního hosta',
        guestTitle: 'Titul',
        selectTitle: 'Vyberte titul',
        mr: 'Pan',
        mrs: 'Paní',
        miss: 'Slečna',
        ms: 'Slečna',
        dr: 'Dr',
        nationality: 'Národnost',
        firstName: 'Jméno',
        lastName: 'Příjmení',
        email: 'E-mail',
        phoneNumber: 'Telefonní číslo',
        additionalInformation: 'Další informace',
        declaration:
          'Potvrzuji, že jsem si přečetl a rozumím podmínkám rezervace a že všechny poskytnuté informace jsou pravdivé a přesné.',
        save: 'Uložit',
      },
    },
    quote_summary: {
      quote_summary: 'Shrnutí nabídky',
      deposit_perc: 'záloha',
      summary: 'Shrnutí',
      viewSummary: 'Zobrazit souhrn',
      accommodation_included: 'Ubytování zahrnuto',
      no_of_adults: 'Počet dospělých',
      no_of_children: 'Počet dětí',
      no_of_teens: 'Počet teenagerů',
      no_of_rooms: 'Počet pokojů',
      arrival_date: 'Datum příjezdu',
      departure_date: 'Datum odjezdu',
      fishing_included: 'Rybaření zahrnuto',
      no_of_anglers: 'Počet rybářů',
      no_of_swims: 'Počet lovišť',
      no_of_fishing_days: 'Počet rybářských dnů',
      fishing_dates: 'Rybařské dny',
      taxis_included: 'Taxi zahrnuto',
      pick_up_date_and_time: 'Datum a čas vyzvednutí',
      pick_up_location: 'Místo vyzvednutí',
      drop_off_date_and_time: 'Datum a čas odvozu',
      drop_off_location: 'Místo odvozu',
      add_ons: 'Doplňky',
      total_price: 'Celková cena',
      pay_today: 'Zaplatit dnes',
      your_quote: 'Vaše nabídka',
      safe_checkout: 'BEZPEČNÁ PLATBA',
      accept_quote: 'PŘIJMOUT NABÍDKU A REZERVOVAT NYNÍ',
      holidayInfoNote:
        'Pro podrobný rozpis všeho, co je zahrnuto ve vaší nabídce, si prosím prohlédněte náš informační balíček o dovolené',
      conversion_note:
        ' Upozorňujeme, že měna bude při platbě převedena na GBP',
      quote_expired:
        'Vaše nabídka vypršela. Kontaktujte prosím rezervační oddělení.',
      availability_note:
        'Upozorňujeme, že nabídka závisí na aktuální dostupnosti v době platby. Prosím proveďte platbu co nejdříve, aby nedošlo ke ztrátě požadovaných termínů.',
      default_description:
        "Děkujeme za váš zájem o rezervaci v Exotic Fishing Thailand! Nemůžeme se dočkat, až vás přivítáme v našem resortu. Zkontrolujte prosím podrobnosti své nabídky v sekci 'Souhrn nabídky' a až budete připraveni pokračovat, klikněte na 'Přijmout nabídku a rezervovat nyní'. Máte otázky? Kontaktujte prosím ",
    },
  },

  ru: {
    reservation: {
      new_reservation: 'Новая бронь',
      packages: 'Пакеты',
      accommodation: 'Проживание',
      fishing: 'Рыбалка',
      Taxi: 'Такси',
      add_ons: 'Дополнения',
      guest_details: 'Данные гостя',
      clearSelection: 'Очистить выбор',
      pleaseSeeYour: 'Пожалуйста, посмотрите ваш',
      quoteBelow: 'Смета ниже',
      packagePrice: 'Цена пакета',
      viewPackage: 'Просмотреть пакет',
      bookNow: 'Забронировать сейчас',
      check_availabilty_book: 'Проверьте доступность и забронируйте сейчас',
      add_reservation_based_on_package:
        'Добавить бронь на основе предустановленного пакета?',
      yes: 'Да',
      no: 'Нет',
      select_package_heading: 'Пожалуйста, выберите из доступных пакетов:',
      no_image: 'Нет изображения',
      last_minute: 'ПОСЛЕДНИЙ МОМЕНТ',
      early_bird: 'РАННЕЕ БРОНИРОВАНИЕ',
      unlimited: 'НЕОГРАНИЧЕННО',
      date_range: 'ПРОМЕЖУТОК ВРЕМЕНИ',
      save_continue: 'Сохранить и продолжить',
      balancePaid: 'Оставшаяся сумма должна быть оплачена до прибытия',
      underStandPrice: 'Я понимаю, что цена будет',
      priceQuotedHere:
        'и указанная цена является приблизительной, основанной на мировых валютных курсах.',
      finalPriceConfirmation: 'Подтверждение окончательной цены',
      accommodationQuestion: 'Включает ли бронь ночлег?',
      edit: 'ИЗМЕНИТЬ',
      step: 'Шаг',
      complete: 'Завершено',
      numberOfGuests: 'Количество гостей:',
      adults: 'Взрослые',
      children: 'Дети',
      teen: 'Подростки',
      numberOfRooms: 'Количество комнат:',
      accommodationAvailabilityReminder:
        'ПОЖАЛУЙСТА, УКАЖИТЕ КОЛИЧЕСТВО ГОСТЕЙ И КОМНАТ ДЛЯ ПРОСМОТРА НАЛИЧИЯ',
      checkIn: 'Заезд',
      checkInPrefix: 'начинается с',
      checkInSuffix: 'в день прибытия',
      checkOut: 'Выезд',
      checkOutPrefix: 'до',
      checkOutSuffix: 'в день отъезда',
      saveAndContinue: 'Сохранить и продолжить',

      fishingQuestion: 'Включает ли бронь рыбалку?',
      selectYourLake: 'Выберите озеро',
      noOfAnglers: 'Количество рыбаков:',
      noOfSwims: 'Количество рыболовных мест:',
      noOfGuest: 'Гости без рыбалки:',
      noOfFishingDays: 'Количество дней рыбалки:',
      completeAnglersSwimsDays:
        'Пожалуйста, укажите количество рыбаков, рыболовных мест и дней рыбалки для просмотра доступности',
      selectYourFishingDates: 'Выберите даты рыбалки:',
      mainLakeTitle: 'Основное озеро',
      mainLakeDescription:
        'Более сотни рыб в этом озере весят более 200 фунтов, включая несколько рекордных экземпляров до 200 фунтов, что гарантирует, что у самых заядлых рыболовов есть долгий список целей при каждом посещении, именно поэтому многие рыбаки возвращаются к нам каждый год.',
      mainLakeAlt: 'Основное озеро',
      EFTKnowTitle: 'Что нужно знать о рыбалке на EFT',
      EFTKnowDescription:
        'Основное озеро предназначено в основном для гостей, проживающих в курорте, в то время как озеро арапайма предназначено для дневных поездок. Рыбакам, проезжающим через Таиланд, которые хотят поймать арапайму, стоит рассмотреть это озеро!',
      arapaimaLakeDescription1:
        'Наше озеро для дневных поездок разработано и заполнено для рыбаков, у которых нет времени на рыбалку во время отпуска, но которые хотят поймать арапайму!',
      arapaimaLakeDescription2:
        'Мы создали озеро, которое может вместить большие группы, добавив много арапаймы.',
      taxiQuestion: 'Включает ли бронь такси/транспорт?',
      addOnsQuestion: 'Включает ли бронь дополнения?',
      taxi: {
        addPickupTaxi: 'Добавить такси для встречи:',
        pickupDateTime: 'Дата и время встречи:',
        pickupLocation: 'Место встречи:',
        addDropoffTaxi: 'Добавить такси для высадки:',
        dropoffDateTime: 'Дата и время высадки:',
        dropoffLocation: 'Место высадки:',
        selectTime: 'Выберите время',
        infoNotAvailableTitle: 'У меня еще нет этой информации',
        infoNotAvailableNote: '(Не волнуйтесь, можно добавить позже!)',
        saveAndContinue: 'Сохранить и продолжить',
        yes: 'Да',
        no: 'Нет',
      },
      cancel: 'Отмена',
      proceedToPayment: 'Перейти к оплате',
      leadGuest: {
        title: 'Данные основного гостя',
        guestTitle: 'Титул',
        selectTitle: 'Выберите титул',
        mr: 'Г-н',
        mrs: 'Г-жа',
        miss: 'Мисс',
        ms: 'Мисс',
        dr: 'Доктор',
        nationality: 'Гражданство',
        firstName: 'Имя',
        lastName: 'Фамилия',
        email: 'Электронная почта',
        phoneNumber: 'Телефонный номер',
        additionalInformation: 'Дополнительная информация',
        declaration:
          'Я подтверждаю, что прочитал и понял условия бронирования и что вся предоставленная информация является правдивой и точной.',
        save: 'Сохранить',
      },
    },
    quote_summary: {
      quote_summary: 'Сводка предложения',
      deposit_perc: 'Депозит',
      summary: 'Сводка',
      viewSummary: 'Просмотреть сводку',
      accommodation_included: 'Проживание включено',
      no_of_adults: 'Количество взрослых',
      no_of_children: 'Количество детей',
      no_of_teens: 'Количество подростков',
      no_of_rooms: 'Количество комнат',
      arrival_date: 'Дата прибытия',
      departure_date: 'Дата отъезда',
      fishing_included: 'Рыбалка включена',
      no_of_anglers: 'Количество рыбаков',
      no_of_swims: 'Количество рыболовных мест',
      no_of_fishing_days: 'Количество дней рыбалки',
      fishing_dates: 'Даты рыбалки',
      taxis_included: 'Такси включено',
      pick_up_date_and_time: 'Дата и время встречи',
      pick_up_location: 'Место встречи',
      drop_off_date_and_time: 'Дата и время высадки',
      drop_off_location: 'Место высадки',
      add_ons: 'Дополнения',
      total_price: 'Итоговая цена',
      pay_today: 'Оплатить сегодня',
      your_quote: 'Ваше предложение',
      safe_checkout: 'БЕЗОПАСНАЯ ОПЛАТА',
      accept_quote: 'ПРИНЯТЬ ПРЕДЛОЖЕНИЕ И ЗАБРОНИРОВАТЬ СЕЙЧАС',
      holidayInfoNote:
        'Для полного разбора всего, что входит в ваше предложение, пожалуйста, ознакомьтесь с нашим информационным пакетом о праздниках',
      conversion_note:
        ' Обратите внимание, что валюта будет конвертирована в GBP при оплате',
      quote_expired:
        'Ваше предложение истекло. Пожалуйста, свяжитесь с отделом бронирования.',
      availability_note:
        'Обратите внимание, что предложение зависит от наличия в реальном времени во время оплаты. Пожалуйста, оплатите как можно скорее, чтобы избежать недоступности запрашиваемых дат.',
      default_description:
        "Благодарим вас за интерес к бронированию Exotic Fishing Thailand! Мы с нетерпением ждем встречи с вами на курорте. Пожалуйста, проверьте детали вашего предложения в разделе 'Сводка предложения' и, когда будете готовы, нажмите 'Принять предложение и забронировать сейчас'. Есть вопросы? Пожалуйста, свяжитесь с ",
    },
  },

  th: {
    reservation: {
      new_reservation: 'การจองใหม่',
      packages: 'แพ็กเกจ',
      accommodation: 'ที่พัก',
      fishing: 'ตกปลา',
      Taxi: 'แท็กซี่',
      add_ons: 'สิ่งเสริม',
      guest_details: 'รายละเอียดแขก',
      clearSelection: 'ล้างการเลือก',
      pleaseSeeYour: 'โปรดดู',
      quoteBelow: 'ใบเสนอราคาด้านล่าง',
      packagePrice: 'ราคาชุด',
      viewPackage: 'ดูแพ็คเกจ',
      bookNow: 'จองตอนนี้',
      check_availabilty_book: 'ตรวจสอบความพร้อมให้บริการและจองตอนนี้',
      add_reservation_based_on_package:
        'เพิ่มการจองโดยอิงจากแพ็กเกจที่ตั้งไว้ล่วงหน้า?',
      yes: 'ใช่',
      no: 'ไม่',
      select_package_heading: 'โปรดเลือกจากแพ็กเกจที่มี:',
      no_image: 'ไม่มีรูปภาพ',
      last_minute: 'นาทีสุดท้าย',
      early_bird: 'จองล่วงหน้า',
      unlimited: 'ไม่จำกัด',
      date_range: 'ช่วงเวลา',
      save_continue: 'บันทึกและดำเนินการต่อ',
      balancePaid: 'ยอดคงเหลือต้องชำระก่อนการเข้าพัก',
      underStandPrice: 'ฉันเข้าใจว่าราคาจะเป็น',
      priceQuotedHere:
        'และราคาที่ระบุไว้ที่นี่เป็นราคาประมาณตามอัตราแลกเปลี่ยนสกุลเงินทั่วโลก',
      finalPriceConfirmation: 'ยืนยันราคาสุดท้าย',
      accommodationQuestion: 'การจองรวมการพักค้างคืนหรือไม่?',
      edit: 'แก้ไข',
      step: 'ขั้นตอน',
      complete: 'เสร็จสิ้น',
      numberOfGuests: 'จำนวนแขก:',
      adults: 'ผู้ใหญ่',
      children: 'เด็ก',
      teen: 'วัยรุ่น',
      numberOfRooms: 'จำนวนห้อง:',
      accommodationAvailabilityReminder:
        'โปรดกรอกจำนวนแขกและห้องเพื่อดูความพร้อมให้บริการ',
      checkIn: 'เช็คอิน',
      checkInPrefix: 'ตั้งแต่',
      checkInSuffix: 'ในวันเดินทางถึง',
      checkOut: 'เช็คเอาท์',
      checkOutPrefix: 'ก่อน',
      checkOutSuffix: 'ในวันเดินทางออก',
      saveAndContinue: 'บันทึกและดำเนินการต่อ',

      fishingQuestion: 'การจองนี้รวมการตกปลาหรือไม่?',
      selectYourLake: 'เลือกทะเลสาบของคุณ',
      noOfAnglers: 'จำนวนชาวประมง:',
      noOfSwims: 'จำนวนจุดตกปลา:',
      noOfGuest: 'แขกที่ไม่ตกปลา:',
      noOfFishingDays: 'จำนวนวันตกปลา:',
      completeAnglersSwimsDays:
        'กรุณากรอกจำนวนชาวประมง จุดตกปลา และวันตกปลาเพื่อดูความพร้อมให้บริการ',
      selectYourFishingDates: 'เลือกวันที่ตกปลาของคุณ:',
      mainLakeTitle: 'ทะเลสาบหลัก',
      mainLakeDescription:
        'มีปลากว่าร้อยตัวในทะเลสาบนี้ที่น้ำหนักเกิน 200 ปอนด์ รวมทั้งปลาบางชนิดที่ทำลายสถิติหนักถึง 200 ปอนด์ ซึ่งทำให้ชาวประมงที่คลั่งไคล้มีเป้าหมายมากมายในแต่ละการเยี่ยมชม นั่นคือเหตุผลที่ชาวประมงจำนวนมากกลับมาเยือนเราทุกปี',
      mainLakeAlt: 'ทะเลสาบหลัก',
      EFTKnowTitle: 'สิ่งที่ควรรู้เกี่ยวกับการตกปลาใน EFT',
      EFTKnowDescription:
        'ทะเลสาบหลักส่วนใหญ่สำหรับแขกที่พักในรีสอร์ต ในขณะที่ทะเลสาบอาราปายามีไว้สำหรับการเดินทางแบบวันเดียว ชาวประมงที่เดินทางผ่านประเทศไทยและต้องการประสบการณ์ตกปลาอาราปายามาควรพิจารณาทะเลสาบนี้!',
      arapaimaLakeDescription1:
        'ทะเลสาบสำหรับวันเดียวของเราได้รับการออกแบบและเติมเต็มสำหรับชาวประมงที่ไม่มีเวลาตกปลาในช่วงวันหยุดแต่ต้องการจับปลาอาราปายามา!',
      arapaimaLakeDescription2:
        'เราสร้างทะเลสาบที่สามารถรองรับกลุ่มใหญ่ได้โดยการเพิ่มอาราปายามามากมาย',
      taxiQuestion: 'การจองนี้รวมบริการแท็กซี่/การขนส่งหรือไม่?',
      addOnsQuestion: 'การจองนี้รวมสิ่งเสริมหรือไม่?',
      taxi: {
        addPickupTaxi: 'เพิ่มแท็กซี่รับ:',
        pickupDateTime: 'วันที่และเวลารับ:',
        pickupLocation: 'สถานที่รับ:',
        addDropoffTaxi: 'เพิ่มแท็กซี่ส่ง:',
        dropoffDateTime: 'วันที่และเวลาส่ง:',
        dropoffLocation: 'สถานที่ส่ง:',
        selectTime: 'เลือกเวลา',
        infoNotAvailableTitle: 'ยังไม่มีข้อมูลนี้',
        infoNotAvailableNote: '(ไม่ต้องกังวล สามารถเพิ่มภายหลังได้!)',
        saveAndContinue: 'บันทึกและดำเนินการต่อ',
        yes: 'ใช่',
        no: 'ไม่',
      },
      cancel: 'ยกเลิก',
      proceedToPayment: 'ไปยังการชำระเงิน',
      leadGuest: {
        title: 'รายละเอียดแขกหลัก',
        guestTitle: 'คำนำหน้า',
        selectTitle: 'เลือกคำนำหน้า',
        mr: 'นาย',
        mrs: 'นาง',
        miss: 'นางสาว',
        ms: 'นางสาว',
        dr: 'ดร.',
        nationality: 'สัญชาติ',
        firstName: 'ชื่อ',
        lastName: 'นามสกุล',
        email: 'อีเมล',
        phoneNumber: 'หมายเลขโทรศัพท์',
        additionalInformation: 'ข้อมูลเพิ่มเติม',
        declaration:
          'ฉันขอยืนยันว่าฉันได้อ่านและเข้าใจข้อกำหนดการจองและข้อมูลทั้งหมดที่ให้ไว้นั้นถูกต้องและเป็นความจริง',
        save: 'บันทึก',
      },
    },
    quote_summary: {
      quote_summary: 'สรุปใบเสนอราคา',
      deposit_perc: 'เงินมัดจำ',
      summary: 'สรุป',
      viewSummary: 'ดูสรุป',
      accommodation_included: 'รวมที่พัก',
      no_of_adults: 'จำนวนผู้ใหญ่',
      no_of_children: 'จำนวนเด็ก',
      no_of_teens: 'จำนวนวัยรุ่น',
      no_of_rooms: 'จำนวนห้อง',
      arrival_date: 'วันที่เดินทางมา',
      departure_date: 'วันที่เดินทางออก',
      fishing_included: 'รวมการตกปลา',
      no_of_anglers: 'จำนวนชาวประมง',
      no_of_swims: 'จำนวนจุดตกปลา',
      no_of_fishing_days: 'จำนวนวันตกปลา',
      fishing_dates: 'วันที่ตกปลา',
      taxis_included: 'รวมแท็กซี่',
      pick_up_date_and_time: 'วันที่และเวลารับ',
      pick_up_location: 'สถานที่รับ',
      drop_off_date_and_time: 'วันที่และเวลาส่ง',
      drop_off_location: 'สถานที่ส่ง',
      add_ons: 'สิ่งเสริม',
      total_price: 'ราคารวม',
      pay_today: 'ชำระวันนี้',
      your_quote: 'ใบเสนอราคาของคุณ',
      safe_checkout: 'ชำระเงินอย่างปลอดภัย',
      accept_quote: 'ยอมรับข้อเสนอและจองตอนนี้',
      holidayInfoNote:
        'สำหรับรายละเอียดทั้งหมดที่รวมอยู่ในใบเสนอราคาของคุณ โปรดดูข้อมูลแพ็คเกจวันหยุดของเราที่นี่',
      conversion_note:
        ' โปรดทราบว่า สกุลเงินจะถูกแปลงเป็น GBP ในขณะที่ชำระเงิน',
      quote_expired: 'ข้อเสนอของคุณหมดอายุ กรุณาติดต่อฝ่ายสำรองที่นั่ง',
      availability_note:
        'โปรดทราบว่า ข้อเสนอขึ้นอยู่กับความพร้อมให้บริการในเวลาชำระเงิน กรุณาชำระเงินโดยเร็วเพื่อหลีกเลี่ยงการสูญเสียวันที่ต้องการ',
      default_description:
        "ขอบคุณที่สนใจจอง Exotic Fishing Thailand! เรารอคอยที่จะต้อนรับคุณสู่รีสอร์ท โปรดตรวจสอบรายละเอียดใบเสนอราคาของคุณในส่วน 'สรุปใบเสนอราคา' และเมื่อพร้อมแล้ว ให้คลิก 'ยอมรับใบเสนอราคาและจองตอนนี้' มีคำถาม? กรุณาติดต่อ ",
    },
  },

  no: {
    reservation: {
      new_reservation: 'Ny reservasjon',
      packages: 'Pakker',
      accommodation: 'Overnatting',
      fishing: 'Fiske',
      Taxi: 'Taxi',
      add_ons: 'Tillegg',
      guest_details: 'Gjestedetaljer',
      clearSelection: 'Fjern valg',
      pleaseSeeYour: 'Vennligst se din',
      quoteBelow: 'Tilbud nedenfor',
      packagePrice: 'Pakkepris',
      viewPackage: 'Se pakke',
      bookNow: 'Bestill nå',
      check_availabilty_book: 'Sjekk tilgjengelighet og bestill nå',
      add_reservation_based_on_package:
        'Legg til reservasjon basert på en forhåndsdefinert pakke?',
      yes: 'Ja',
      no: 'Nei',
      select_package_heading: 'Vennligst velg fra tilgjengelige pakker:',
      no_image: 'Ingen bilde',
      last_minute: 'SISTE MINUTT',
      early_bird: 'TIDLIG BESTILLING',
      unlimited: 'Ubegrenset',
      date_range: 'Tidsperiode',
      save_continue: 'Lagre og fortsett',
      balancePaid: 'Restbeløp må betales før oppholdet',
      underStandPrice: 'Jeg forstår at prisen vil være',
      priceQuotedHere:
        'og prisen som er oppgitt her er en omtrentlig basert på globale valutakurser.',
      finalPriceConfirmation: 'Endelig prisbekreftelse',
      accommodationQuestion: 'Inkluderer denne reservasjonen overnatting?',
      edit: 'REDIGER',
      step: 'Trinn',
      complete: 'Fullført',
      numberOfGuests: 'Antall gjester:',
      adults: 'Voksne',
      children: 'Barn',
      teen: 'Tenåringer',
      numberOfRooms: 'Antall rom:',
      accommodationAvailabilityReminder:
        'VENNLIGST OPPGI ANTALL GJESTER OG ROM FOR Å SE TILGJENGELIGHET',
      checkIn: 'Innsjekking',
      checkInPrefix: 'starter fra',
      checkInSuffix: 'på ankomstdagen',
      checkOut: 'Utsjekking',
      checkOutPrefix: 'før',
      checkOutSuffix: 'på avreisedagen',
      saveAndContinue: 'Lagre og fortsett',

      fishingQuestion: 'Inkluderer denne reservasjonen fiske?',
      selectYourLake: 'Velg innsjøen din',
      noOfAnglers: 'Antall fiskere:',
      noOfSwims: 'Antall fiskeplasser:',
      noOfGuest: 'Gjester som ikke fisker:',
      noOfFishingDays: 'Antall fiskedager:',
      completeAnglersSwimsDays:
        'Vennligst oppgi antall fiskere, fiskeplasser og fiskedager for å se tilgjengelighet',
      selectYourFishingDates: 'Velg fiskedatoene dine:',
      mainLakeTitle: 'Hovedinnsjø',
      mainLakeDescription:
        'Det er over hundre fisk i denne innsjøen som veier over 200 pund, inkludert flere rekordstore fisk på opptil 200 pund, noe som sikrer at de mest ivrige fiskerne har en lang liste med mål ved hvert besøk, og derfor kommer mange fiskere tilbake til oss hvert år.',
      mainLakeAlt: 'Hovedinnsjø',
      EFTKnowTitle: 'Hva du bør vite om fiske på EFT',
      EFTKnowDescription:
        'Hovedinnsjøen er primært for gjester som bor på resorten, mens arapaimasjøen er for dagsturer. Fiskere som reiser gjennom Thailand og ønsker å oppleve Arapaima, bør vurdere denne innsjøen!',
      arapaimaLakeDescription1:
        'Vår dagstursjø er designet og fylt for fiskere som ikke har tid til å fiske i ferien, men ønsker å fange Arapaima!',
      arapaimaLakeDescription2:
        'Vi har laget en innsjø som kan romme store grupper ved å legge til mange Arapaima.',
      taxiQuestion: 'Inkluderer denne reservasjonen taxi/transport?',
      addOnsQuestion: 'Inkluderer denne reservasjonen tillegg?',
      taxi: {
        addPickupTaxi: 'Legg til hentingstaxi:',
        pickupDateTime: 'Hentingsdato og -tid:',
        pickupLocation: 'Hentingssted:',
        addDropoffTaxi: 'Legg til avleveringstaxi:',
        dropoffDateTime: 'Avleveringsdato og -tid:',
        dropoffLocation: 'Avleveringssted:',
        selectTime: 'Velg tid',
        infoNotAvailableTitle: 'Jeg har ikke denne informasjonen ennå',
        infoNotAvailableNote: '(Ikke bekymre deg, det kan legges til senere!)',
        saveAndContinue: 'Lagre og fortsett',
        yes: 'Ja',
        no: 'Nei',
      },
      cancel: 'Avbryt',
      proceedToPayment: 'Fortsett til betaling',
      leadGuest: {
        title: 'Detaljer om hovedgjesten',
        guestTitle: 'Tittel',
        selectTitle: 'Velg tittel',
        mr: 'Herr',
        mrs: 'Fru',
        miss: 'Frøken',
        ms: 'Frøken',
        dr: 'Dr.',
        nationality: 'Nasjonalitet',
        firstName: 'Fornavn',
        lastName: 'Etternavn',
        email: 'E-post',
        phoneNumber: 'Telefonnummer',
        additionalInformation: 'Tilleggsinformasjon',
        declaration:
          'Jeg bekrefter at jeg har lest og forstått vilkårene for reservasjonen og at all informasjon som er gitt er sann og korrekt.',
        save: 'Lagre',
      },
    },
    quote_summary: {
      quote_summary: 'Sammendrag av tilbud',
      deposit_perc: 'depositum',
      summary: 'Sammendrag',
      viewSummary: 'Se sammendrag',
      accommodation_included: 'Overnatting inkludert',
      no_of_adults: 'Antall voksne',
      no_of_children: 'Antall barn',
      no_of_teens: 'Antall tenåringer',
      no_of_rooms: 'Antall rom',
      arrival_date: 'Ankomstdato',
      departure_date: 'Avreisedato',
      fishing_included: 'Fiske inkludert',
      no_of_anglers: 'Antall fiskere',
      no_of_swims: 'Antall fiskeplasser',
      no_of_fishing_days: 'Antall fiskedager',
      fishing_dates: 'Fiskedatoer',
      taxis_included: 'Taxi inkludert',
      pick_up_date_and_time: 'Hentingsdato og -tid',
      pick_up_location: 'Hentingssted',
      drop_off_date_and_time: 'Avleveringsdato og -tid',
      drop_off_location: 'Avleveringssted',
      add_ons: 'Tillegg',
      total_price: 'Totalpris',
      pay_today: 'Betal i dag',
      your_quote: 'Ditt tilbud',
      safe_checkout: 'Sikker betaling',
      accept_quote: 'Godta tilbudet og bestill nå',
      holidayInfoNote:
        'For en omfattende oversikt over alt som er inkludert i tilbudet ditt, vennligst se vår ferieinformasjonsbrosjyre',
      conversion_note:
        ' Vennligst merk at valuta konverteres til GBP ved betaling',
      quote_expired:
        'Ditt tilbud er utløpt. Vennligst kontakt reservasjonsteamet.',
      availability_note:
        'Vennligst merk at tilbudet avhenger av tilgjengelighet ved betaling. Vennligst betal raskt for å unngå tap av ønskede datoer.',
      default_description:
        "Takk for din interesse for å bestille Exotic Fishing Thailand! Vi gleder oss til å ønske deg velkommen til resorten. Vennligst verifiser tilbudsdetaljene dine i 'Tilbudssammendraget', og når du er klar til å fortsette, klikk på 'Godta tilbud og bestill nå'. Har du spørsmål? Ta kontakt med ",
    },
  },

  it: {
    reservation: {
      new_reservation: 'Nuova prenotazione',
      packages: 'Pacchetti',
      accommodation: 'Alloggio',
      fishing: 'Pesca',
      Taxi: 'Taxi',
      add_ons: 'Extra',
      guest_details: 'Dettagli ospite',
      clearSelection: 'Cancella selezione',
      pleaseSeeYour: 'Si prega di vedere il tuo',
      quoteBelow: 'Preventivo qui sotto',
      packagePrice: 'Prezzo del pacchetto',
      viewPackage: 'Visualizza pacchetto',
      bookNow: 'Prenota ora',
      check_availabilty_book: 'Controlla disponibilità e prenota ora',
      add_reservation_based_on_package:
        'Aggiungere una prenotazione basata su un pacchetto predefinito?',
      yes: 'Sì',
      no: 'No',
      select_package_heading:
        'Si prega di selezionare tra i pacchetti disponibili:',
      no_image: 'Nessuna immagine',
      last_minute: 'ULTIMO MINUTO',
      early_bird: 'PRENOTAZIONE ANTICIPATA',
      unlimited: 'Illimitato',
      date_range: 'Intervallo date',
      save_continue: 'Salva e continua',
      balancePaid: 'Saldo da pagare prima del soggiorno',
      underStandPrice: 'Capisco che il prezzo sarà',
      priceQuotedHere:
        "e il prezzo indicato qui è un'approssimazione basata sui tassi di cambio globali.",
      finalPriceConfirmation: 'Conferma del prezzo finale',
      accommodationQuestion: 'Questa prenotazione include l’alloggio?',
      edit: 'MODIFICA',
      step: 'Passo',
      complete: 'Completo',
      numberOfGuests: 'Numero di ospiti:',
      adults: 'Adulti',
      children: 'Bambini',
      teen: 'Adolescenti',
      numberOfRooms: 'Numero di camere:',
      accommodationAvailabilityReminder:
        'PER FAVORE, INSERISCI IL NUMERO DI OSPITI E CAMERE PER VEDERE LA DISPONIBILITÀ',
      checkIn: 'Check-in',
      checkInPrefix: 'da',
      checkInSuffix: 'il giorno di arrivo',
      checkOut: 'Check-out',
      checkOutPrefix: 'prima di',
      checkOutSuffix: 'il giorno di partenza',
      saveAndContinue: 'Salva e continua',

      fishingQuestion: 'Questa prenotazione include la pesca?',
      selectYourLake: 'Seleziona il lago',
      noOfAnglers: 'Numero di pescatori:',
      noOfSwims: 'Numero di postazioni di pesca:',
      noOfGuest: 'Ospiti non pescatori:',
      noOfFishingDays: 'Numero di giorni di pesca:',
      completeAnglersSwimsDays:
        'Per favore inserisci il numero di pescatori, postazioni e giorni di pesca per vedere la disponibilità',
      selectYourFishingDates: 'Seleziona le date di pesca:',
      mainLakeTitle: 'Lago principale',
      mainLakeDescription:
        'Ci sono oltre cento pesci in questo lago che pesano più di 90 kg, inclusi diversi pesci record fino a 90 kg, assicurando che i pescatori più appassionati abbiano una lunga lista di obiettivi a ogni visita. Per questo molti pescatori tornano ogni anno.',
      mainLakeAlt: 'Lago principale',
      EFTKnowTitle: 'Cosa sapere sulla pesca a EFT',
      EFTKnowDescription:
        'Il lago principale è principalmente per gli ospiti che soggiornano nel resort, mentre il lago Arapaima è per le escursioni di un giorno. I pescatori che viaggiano in Thailandia e desiderano provare l’Arapaima dovrebbero prendere in considerazione questo lago!',
      arapaimaLakeDescription1:
        'Il nostro lago per gite di un giorno è progettato e rifornito per pescatori che non hanno tempo per pescare durante le vacanze ma vogliono catturare l’Arapaima!',
      arapaimaLakeDescription2:
        'Abbiamo creato un lago che può ospitare grandi gruppi aggiungendo molte Arapaima.',
      taxiQuestion: 'Questa prenotazione include taxi/trasporto?',
      addOnsQuestion: 'Questa prenotazione include extra?',
      taxi: {
        addPickupTaxi: 'Aggiungi taxi per il ritiro:',
        pickupDateTime: 'Data e ora ritiro:',
        pickupLocation: 'Luogo di ritiro:',
        addDropoffTaxi: 'Aggiungi taxi per la riconsegna:',
        dropoffDateTime: 'Data e ora riconsegna:',
        dropoffLocation: 'Luogo di riconsegna:',
        selectTime: 'Seleziona orario',
        infoNotAvailableTitle: 'Informazioni non disponibili',
        infoNotAvailableNote: '(Non preoccuparti, potrai aggiungerle dopo!)',
        saveAndContinue: 'Salva e continua',
        yes: 'Sì',
        no: 'No',
      },
      cancel: 'Annulla',
      proceedToPayment: 'Procedi al pagamento',
      leadGuest: {
        title: 'Dettagli ospite principale',
        guestTitle: 'Titolo',
        selectTitle: 'Seleziona titolo',
        mr: 'Sig.',
        mrs: 'Sig.ra',
        miss: 'Sig.na',
        ms: 'Sig.na',
        dr: 'Dott.',
        nationality: 'Nazionalità',
        firstName: 'Nome',
        lastName: 'Cognome',
        email: 'Email',
        phoneNumber: 'Numero di telefono',
        additionalInformation: 'Informazioni aggiuntive',
        declaration:
          'Confermo di aver letto e compreso i termini della prenotazione e che tutte le informazioni fornite sono corrette e veritiere.',
        save: 'Salva',
      },
    },
    quote_summary: {
      quote_summary: 'Riepilogo preventivo',
      deposit_perc: 'Acconto',
      summary: 'Riepilogo',
      viewSummary: 'Visualizza riepilogo',
      accommodation_included: 'Alloggio incluso',
      no_of_adults: 'Numero di adulti',
      no_of_children: 'Numero di bambini',
      no_of_teens: 'Numero di adolescenti',
      no_of_rooms: 'Numero di camere',
      arrival_date: 'Data di arrivo',
      departure_date: 'Data di partenza',
      fishing_included: 'Pesca inclusa',
      no_of_anglers: 'Numero di pescatori',
      no_of_swims: 'Numero di postazioni di pesca',
      no_of_fishing_days: 'Numero di giorni di pesca',
      fishing_dates: 'Date di pesca',
      taxis_included: 'Taxi inclusi',
      pick_up_date_and_time: 'Data e ora ritiro',
      pick_up_location: 'Luogo di ritiro',
      drop_off_date_and_time: 'Data e ora riconsegna',
      drop_off_location: 'Luogo di riconsegna',
      add_ons: 'Extra',
      total_price: 'Prezzo totale',
      pay_today: 'Paga oggi',
      your_quote: 'Il tuo preventivo',
      safe_checkout: 'Pagamento sicuro',
      accept_quote: 'Accetta il preventivo e prenota ora',
      holidayInfoNote:
        'Per una panoramica completa di tutto ciò che è incluso nel tuo preventivo, consulta il nostro pacchetto informativo sulla vacanza',
      conversion_note:
        ' Si prega di notare che la valuta verrà convertita in GBP al momento del pagamento',
      quote_expired:
        'Il tuo preventivo è scaduto. Si prega di contattare il team prenotazioni.',
      availability_note:
        'Si prega di notare che il preventivo dipende dalla disponibilità al momento del pagamento. Si prega di pagare rapidamente per evitare la perdita delle date desiderate.',
      default_description:
        "Grazie per l'interesse nel prenotare Exotic Fishing Thailand! Non vediamo l'ora di darti il benvenuto al resort. Verifica i dettagli del preventivo nella sezione 'Riepilogo Preventivo' e, quando sei pronto, clicca su 'Accetta Preventivo e Prenota Ora'. Domande? Contatta ",
    },
  },

  fr: {
    reservation: {
      new_reservation: 'Nouvelle réservation',
      packages: 'Forfaits',
      accommodation: 'Hébergement',
      fishing: 'Pêche',
      Taxi: 'Taxi',
      add_ons: 'Suppléments',
      guest_details: 'Détails des invités',
      clearSelection: 'Effacer la sélection',
      pleaseSeeYour: 'Veuillez consulter votre',
      quoteBelow: 'Devis ci-dessous',
      packagePrice: 'Prix du forfait',
      viewPackage: 'Voir le forfait',
      bookNow: 'Réserver maintenant',
      check_availabilty_book:
        'Vérifiez la disponibilité et réservez maintenant',
      add_reservation_based_on_package:
        'Ajouter une réservation basée sur un forfait prédéfini ?',
      yes: 'Oui',
      no: 'Non',
      select_package_heading:
        'Veuillez sélectionner parmi les forfaits disponibles :',
      no_image: 'Pas d’image',
      last_minute: 'DERNIÈRE MINUTE',
      early_bird: 'EARLY BIRD',
      unlimited: 'ILLIMITÉ',
      date_range: 'PLAGE DE DATES',
      save_continue: 'Enregistrer et continuer',
      balancePaid: 'Solde à payer avant le séjour',
      underStandPrice: 'Je comprends que le prix sera',
      priceQuotedHere:
        'et le prix indiqué ici est une approximation basée sur les taux de change mondiaux.',
      finalPriceConfirmation: 'Confirmation du prix final',
      accommodationQuestion: 'Cette réservation inclut-elle un hébergement ?',
      edit: 'MODIFIER',
      step: 'Étape',
      complete: 'Terminé',
      numberOfGuests: "Nombre d'invités :",
      adults: 'Adulte',
      children: 'Enfant',
      teen: 'Adolescent',
      numberOfRooms: 'Nombre de chambres :',
      accommodationAvailabilityReminder:
        'VEUILLEZ RENSEIGNER LE NOMBRE D’INVITÉS ET DE CHAMBRES POUR VOIR LA DISPONIBILITÉ',
      checkIn: 'Arrivée',
      checkInPrefix: 'à partir de',
      checkInSuffix: "le jour d'arrivée",
      checkOut: 'Départ',
      checkOutPrefix: 'avant',
      checkOutSuffix: 'le jour de départ',
      saveAndContinue: 'Enregistrer et continuer',

      fishingQuestion: 'Cette réservation inclut-elle la pêche ?',
      selectYourLake: 'Sélectionnez votre lac',
      noOfAnglers: 'Nombre de pêcheurs :',
      noOfSwims: 'Nombre d’emplacements :',
      noOfGuest: 'Invités non pêcheurs :',
      noOfFishingDays: 'Nombre de jours de pêche :',
      completeAnglersSwimsDays:
        'Veuillez compléter le nombre de pêcheurs, d’emplacements et de jours de pêche pour voir la disponibilité',
      selectYourFishingDates: 'Sélectionnez vos dates de pêche :',
      mainLakeTitle: 'Le lac principal',
      mainLakeDescription:
        'Plus d’une centaine de poissons de ce lac pèsent plus de 90 kg, y compris plusieurs spécimens record jusqu’à 90 kg, garantissant aux passionnés une longue liste de cibles à chaque visite, ce qui explique pourquoi beaucoup reviennent chaque année.',
      mainLakeAlt: 'Lac principal',
      EFTKnowTitle: 'À savoir sur la pêche à EFT',
      EFTKnowDescription:
        'Le lac principal est principalement réservé aux clients séjournant au resort, tandis que le lac Arapaima est destiné aux excursions d’une journée. Les pêcheurs en visite en Thaïlande désirant une expérience unique avec l’Arapaima devraient considérer ce lac !',
      arapaimaLakeDescription1:
        'Notre lac pour les sorties d’un jour est conçu et peuplé pour les pêcheurs qui n’ont pas le temps de pêcher pendant leurs vacances mais souhaitent attraper un Arapaima !',
      arapaimaLakeDescription2:
        'Nous avons créé un lac pouvant accueillir de grands groupes en introduisant un grand nombre d’Arapaima.',
      taxiQuestion: 'Cette réservation inclut-elle des taxis / transferts ?',
      addOnsQuestion: 'Cette réservation inclut-elle des suppléments ?',
      taxi: {
        addPickupTaxi: 'Ajouter taxi pour prise en charge :',
        pickupDateTime: 'Date et heure de prise en charge :',
        pickupLocation: 'Lieu de prise en charge :',
        addDropoffTaxi: 'Ajouter taxi pour dépose :',
        dropoffDateTime: 'Date et heure de dépose :',
        dropoffLocation: 'Lieu de dépose :',
        selectTime: 'Sélectionner l’heure',
        infoNotAvailableTitle: 'Je n’ai pas encore cette information',
        infoNotAvailableNote:
          '(Ne vous inquiétez pas, vous pouvez l’ajouter plus tard !)',
        saveAndContinue: 'Enregistrer et continuer',
        yes: 'Oui',
        no: 'Non',
      },
      cancel: 'Annuler',
      proceedToPayment: 'Passer au paiement',
      leadGuest: {
        title: "Détails de l'invité principal",
        guestTitle: 'Titre',
        selectTitle: 'Sélectionnez un titre',
        mr: 'M.',
        mrs: 'Mme',
        miss: 'Mlle',
        ms: 'Mme',
        dr: 'Dr',
        nationality: 'Nationalité',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Email',
        phoneNumber: 'Numéro de téléphone',
        additionalInformation: 'Informations supplémentaires',
        declaration:
          'Je confirme avoir lu et compris les conditions de réservation et que toutes les informations fournies sont exactes.',
        save: 'Enregistrer',
      },
    },
    quote_summary: {
      quote_summary: 'Résumé du devis',
      deposit_perc: 'Acompte de',
      summary: 'Résumé',
      viewSummary: 'Voir le résumé',
      accommodation_included: 'Hébergement inclus',
      no_of_adults: 'Nombre d’adultes',
      no_of_children: 'Nombre d’enfants',
      no_of_teens: 'Nombre d’adolescents',
      no_of_rooms: 'Nombre de chambres',
      arrival_date: "Date d'arrivée",
      departure_date: 'Date de départ',
      fishing_included: 'Pêche incluse',
      no_of_anglers: 'Nombre de pêcheurs',
      no_of_swims: 'Nombre d’emplacements',
      no_of_fishing_days: 'Nombre de jours de pêche',
      fishing_dates: 'Dates de pêche',
      taxis_included: 'Taxis inclus',
      pick_up_date_and_time: 'Date et heure de prise en charge',
      pick_up_location: 'Lieu de prise en charge',
      drop_off_date_and_time: 'Date et heure de dépose',
      drop_off_location: 'Lieu de dépose',
      add_ons: 'Suppléments',
      total_price: 'Prix total',
      pay_today: 'Payer aujourd’hui',
      your_quote: 'Votre devis',
      safe_checkout: 'PAIEMENT SÉCURISÉ',
      accept_quote: 'ACCEPTER LE DEVIS & RÉSERVER',
      holidayInfoNote:
        "Pour une ventilation complète de tout ce qui est inclus dans votre devis, veuillez consulter notre pack d'informations sur les vacances",
      conversion_note:
        ' Veuillez noter que la devise sera convertie en GBP au moment du paiement',
      quote_expired:
        'Votre devis a expiré. Veuillez contacter les réservations.',
      availability_note:
        'Veuillez noter que les devis sont soumis à disponibilité au moment du paiement. Veuillez payer rapidement pour sécuriser vos dates demandées.',
      default_description:
        "Merci de votre intérêt pour réserver Exotic Fishing Thailand ! Nous avons hâte de vous accueillir au resort. Veuillez vérifier les détails de votre devis dans la section 'Résumé du devis' et, lorsque vous êtes prêt à continuer, cliquez sur 'Accepter le devis et réserver maintenant'. Des questions ? Veuillez contacter ",
    },
  },

  es: {
    reservation: {
      new_reservation: 'Nueva reserva',
      packages: 'Paquetes',
      accommodation: 'Alojamiento',
      fishing: 'Pesca',
      Taxi: 'Taxi',
      add_ons: 'Extras',
      guest_details: 'Detalles del huésped',
      clearSelection: 'Borrar selección',
      pleaseSeeYour: 'Por favor, revise su',
      quoteBelow: 'Cotización abajo',
      packagePrice: 'Precio del paquete',
      viewPackage: 'Ver paquete',
      bookNow: 'Reservar ahora',
      check_availabilty_book: 'Consultar disponibilidad y reservar ahora',
      add_reservation_based_on_package:
        '¿Agregar una reserva basada en un paquete predeterminado?',
      yes: 'Sí',
      no: 'No',
      select_package_heading:
        'Por favor seleccione entre los paquetes disponibles:',
      no_image: 'Sin imagen',
      last_minute: 'ÚLTIMO MINUTO',
      early_bird: 'RESERVA ANTICIPADA',
      unlimited: 'ILIMITADO',
      date_range: 'RANGO DE FECHAS',
      save_continue: 'Guardar y continuar',
      balancePaid: 'Saldo a pagar antes de la estancia',
      underStandPrice: 'Entiendo que el precio será',
      priceQuotedHere:
        'y el precio aquí citado es una aproximación basada en los tipos de cambio globales.',
      finalPriceConfirmation: 'Confirmación del precio final',
      accommodationQuestion: '¿Esta reserva incluye alojamiento?',
      edit: 'EDITAR',
      step: 'Paso',
      complete: 'Completo',
      numberOfGuests: 'Número de huéspedes:',
      adults: 'Adulto',
      children: 'Niño',
      teen: 'Adolescente',
      numberOfRooms: 'Número de habitaciones:',
      accommodationAvailabilityReminder:
        'POR FAVOR COMPLETE EL NÚMERO DE HUÉSPEDES Y HABITACIONES PARA VER DISPONIBILIDAD',
      checkIn: 'Check-in',
      checkInPrefix: 'a partir de',
      checkInSuffix: 'en el día de llegada',
      checkOut: 'Check-out',
      checkOutPrefix: 'antes de',
      checkOutSuffix: 'en el día de salida',
      saveAndContinue: 'Guardar y continuar',

      fishingQuestion: '¿Esta reserva incluye pesca?',
      selectYourLake: 'Seleccione su lago',
      noOfAnglers: 'Número de pescadores:',
      noOfSwims: 'Número de puestos de pesca:',
      noOfGuest: 'Invitados no pescadores:',
      noOfFishingDays: 'Número de días de pesca:',
      completeAnglersSwimsDays:
        'Por favor complete el número de pescadores, puestos y días de pesca para ver disponibilidad',
      selectYourFishingDates: 'Seleccione sus fechas de pesca:',
      mainLakeTitle: 'El lago principal',
      mainLakeDescription:
        'Más de cien peces en este lago superan las 90 kg, incluyendo varios ejemplares récord hasta 90 kg, asegurando que incluso los pescadores más apasionados tengan una larga lista de objetivos en cada visita, razón por la cual muchos regresan año tras año.',
      mainLakeAlt: 'Lago principal',
      EFTKnowTitle: 'Cosas que saber sobre la pesca en EFT',
      EFTKnowDescription:
        'El lago principal es principalmente para los huéspedes que se alojan en el resort, mientras que el lago Arapaima está preparado para excursiones de un día. ¡Los pescadores que viajan a Tailandia y desean una experiencia inolvidable con Arapaima deberían considerar seriamente este lago!',
      arapaimaLakeDescription1:
        'Nuestro lago para excursiones de un día está diseñado y abastecido para pescadores que no tienen tiempo para pescar durante sus vacaciones, ¡pero quieren atrapar un Arapaima!',
      arapaimaLakeDescription2:
        'Hemos creado un lago que puede atender a grandes grupos de clientes introduciendo un gran número de Arapaima.',
      taxiQuestion: '¿Esta reserva incluye taxis / traslados?',
      addOnsQuestion: '¿Esta reserva incluye extras?',
      taxi: {
        addPickupTaxi: 'Agregar taxi de recogida:',
        pickupDateTime: 'Fecha y hora de recogida:',
        pickupLocation: 'Lugar de recogida:',
        addDropoffTaxi: 'Agregar taxi de regreso:',
        dropoffDateTime: 'Fecha y hora de regreso:',
        dropoffLocation: 'Lugar de regreso:',
        selectTime: 'Seleccionar hora',
        infoNotAvailableTitle: 'Todavía no tengo esta información',
        infoNotAvailableNote: '(¡No se preocupe, puede agregarlo más tarde!)',
        saveAndContinue: 'Guardar y continuar',
        yes: 'Sí',
        no: 'No',
      },
      cancel: 'Cancelar',
      proceedToPayment: 'Proceder al pago',
      leadGuest: {
        title: 'Detalles del huésped principal',
        guestTitle: 'Título',
        selectTitle: 'Seleccione un título',
        mr: 'Sr.',
        mrs: 'Sra.',
        miss: 'Srta.',
        ms: 'Sra.',
        dr: 'Dr.',
        nationality: 'Nacionalidad',
        firstName: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo electrónico',
        phoneNumber: 'Número de teléfono',
        additionalInformation: 'Información adicional',
        declaration:
          'Confirmo que he leído y entendido las condiciones de reserva y que toda la información proporcionada es correcta.',
        save: 'Guardar',
      },
    },
    quote_summary: {
      quote_summary: 'Resumen del presupuesto',
      deposit_perc: 'Depósito del',
      summary: 'Resumen',
      viewSummary: 'Ver resumen',
      accommodation_included: 'Alojamiento incluido',
      no_of_adults: 'Número de adultos',
      no_of_children: 'Número de niños',
      no_of_teens: 'Número de adolescentes',
      no_of_rooms: 'Número de habitaciones',
      arrival_date: 'Fecha de llegada',
      departure_date: 'Fecha de salida',
      fishing_included: 'Pesca incluida',
      no_of_anglers: 'Número de pescadores',
      no_of_swims: 'Número de puestos de pesca',
      no_of_fishing_days: 'Número de días de pesca',
      fishing_dates: 'Fechas de pesca',
      taxis_included: 'Taxis incluidos',
      pick_up_date_and_time: 'Fecha y hora de recogida',
      pick_up_location: 'Lugar de recogida',
      drop_off_date_and_time: 'Fecha y hora de regreso',
      drop_off_location: 'Lugar de regreso',
      add_ons: 'Extras',
      total_price: 'Precio total',
      pay_today: 'Pagar hoy',
      your_quote: 'Su presupuesto',
      safe_checkout: 'PAGO SEGURO',
      accept_quote: 'ACEPTAR PRESUPUESTO Y RESERVAR',
      holidayInfoNote:
        'Para ver un desglose completo de todo lo incluido en su presupuesto, consulte nuestro paquete de información de vacaciones',
      conversion_note:
        ' Tenga en cuenta que la moneda se convertirá a GBP en el momento del pago',
      quote_expired:
        'Su presupuesto ha expirado. Por favor, contacte con reservas.',
      availability_note:
        'Tenga en cuenta que los presupuestos están sujetos a disponibilidad en el momento del pago. Por favor, pague rápidamente para asegurar sus fechas solicitadas.',
      default_description:
        "Gracias por su interés en reservar Exotic Fishing Thailand. ¡Estamos deseando darle la bienvenida al resort! Por favor, verifique los detalles de su presupuesto en la sección 'Resumen del presupuesto' y cuando esté listo para continuar, haga clic en 'Aceptar presupuesto y reservar ahora'. ¿Tiene preguntas? Por favor, contacte a ",
    },
  },

  pl: {
    reservation: {
      new_reservation: 'Nowa rezerwacja',
      packages: 'Pakiety',
      accommodation: 'Zakwaterowanie',
      fishing: 'Wędkarstwo',
      Taxi: 'Taxi',
      add_ons: 'Dodatki',
      guest_details: 'Szczegóły gościa',
      clearSelection: 'Wyczyść wybór',
      pleaseSeeYour: 'Proszę zobaczyć swój',
      quoteBelow: 'Wycena poniżej',
      packagePrice: 'Cena pakietu',
      viewPackage: 'Zobacz pakiet',
      bookNow: 'Zarezerwuj teraz',
      check_availabilty_book: 'Sprawdź dostępność i zarezerwuj teraz',
      add_reservation_based_on_package:
        'Czy dodać rezerwację na podstawie zdefiniowanego pakietu?',
      yes: 'Tak',
      no: 'Nie',
      select_package_heading: 'Proszę wybrać spośród dostępnych pakietów:',
      no_image: 'Brak zdjęcia',
      last_minute: 'OSTATNIA CHWILA',
      early_bird: 'WCZESNA REZERWACJA',
      unlimited: 'NIEOGRANICZONY',
      date_range: 'Zakres dat',
      save_continue: 'Zapisz i kontynuuj',
      balancePaid: 'Pozostała kwota do zapłaty przed pobytem',
      underStandPrice: 'Rozumiem, że cena będzie',
      priceQuotedHere:
        'a podana cena jest przybliżona na podstawie globalnych kursów walut.',
      finalPriceConfirmation: 'Ostateczne potwierdzenie ceny',
      accommodationQuestion: 'Czy ta rezerwacja obejmuje zakwaterowanie?',
      edit: 'EDYTUJ',
      step: 'Krok',
      complete: 'Zakończono',
      numberOfGuests: 'Liczba gości:',
      adults: 'Dorosły',
      children: 'Dziecko',
      teen: 'Nastolatek',
      numberOfRooms: 'Liczba pokoi:',
      accommodationAvailabilityReminder:
        'PROSZĘ WPISAĆ LICZBĘ GOŚCI I POKOI, ABY SPRAWDZIĆ DOSTĘPNOŚĆ',
      checkIn: 'Zameldowanie',
      checkInPrefix: 'od',
      checkInSuffix: 'w dniu przyjazdu',
      checkOut: 'Wymeldowanie',
      checkOutPrefix: 'do',
      checkOutSuffix: 'w dniu wyjazdu',
      saveAndContinue: 'Zapisz i kontynuuj',

      fishingQuestion: 'Czy ta rezerwacja obejmuje wędkowanie?',
      selectYourLake: 'Wybierz swój zbiornik wodny',
      noOfAnglers: 'Liczba wędkarzy:',
      noOfSwims: 'Liczba stanowisk wędkarskich:',
      noOfGuest: 'Goście niełowiący:',
      noOfFishingDays: 'Liczba dni wędkowania:',
      completeAnglersSwimsDays:
        'Proszę uzupełnić liczbę wędkarzy, stanowisk i dni wędkowania, aby zobaczyć dostępność',
      selectYourFishingDates: 'Wybierz daty wędkowania:',
      mainLakeTitle: 'Główny zbiornik wodny',
      mainLakeDescription:
        'Ponad sto ryb w tym zbiorniku waży ponad 90 kg, w tym kilka rekordowych okazów do 90 kg, zapewniając zapalonym wędkarzom długą listę celów podczas każdej wizyty, dlatego wielu wraca co roku.',
      mainLakeAlt: 'Główny zbiornik',
      EFTKnowTitle: 'Warto wiedzieć o wędkarstwie w EFT',
      EFTKnowDescription:
        'Główny zbiornik jest przeznaczony głównie dla gości resortu, natomiast zbiornik Arapaima jest przygotowany na jednodniowe wypady. Wędkarze odwiedzający Tajlandię, którzy chcą wyjątkowego doświadczenia z Arapaimą, powinni poważnie rozważyć ten zbiornik!',
      arapaimaLakeDescription1:
        'Nasz zbiornik na jednodniowe wypady jest zaprojektowany i zarybiony dla wędkarzy, którzy nie mają czasu na wędkowanie podczas wakacji, ale chcą złowić Arapaimę!',
      arapaimaLakeDescription2:
        'Stworzyliśmy zbiornik mogący pomieścić duże grupy klientów, wprowadzając dużą liczbę Arapaim.',
      taxiQuestion: 'Czy ta rezerwacja obejmuje taksówki / transfery?',
      addOnsQuestion: 'Czy ta rezerwacja obejmuje dodatki?',
      taxi: {
        addPickupTaxi: 'Dodaj taxi na odbiór:',
        pickupDateTime: 'Data i godzina odbioru:',
        pickupLocation: 'Miejsce odbioru:',
        addDropoffTaxi: 'Dodaj taxi na dowóz:',
        dropoffDateTime: 'Data i godzina dowozu:',
        dropoffLocation: 'Miejsce dowozu:',
        selectTime: 'Wybierz czas',
        infoNotAvailableTitle: 'Nie mam jeszcze tych informacji',
        infoNotAvailableNote: '(Nie martw się, możesz dodać je później!)',
        saveAndContinue: 'Zapisz i kontynuuj',
        yes: 'Tak',
        no: 'Nie',
      },
      cancel: 'Anuluj',
      proceedToPayment: 'Przejdź do płatności',
      leadGuest: {
        title: 'Szczegóły głównego gościa',
        guestTitle: 'Tytuł',
        selectTitle: 'Wybierz tytuł',
        mr: 'Pan',
        mrs: 'Pani',
        miss: 'Panna',
        ms: 'Pani',
        dr: 'Dr',
        nationality: 'Narodowość',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        email: 'Email',
        phoneNumber: 'Numer telefonu',
        additionalInformation: 'Dodatkowe informacje',
        declaration:
          'Potwierdzam, że przeczytałem i zrozumiałem warunki rezerwacji oraz że wszystkie podane informacje są prawdziwe.',
        save: 'Zapisz',
      },
    },
    quote_summary: {
      quote_summary: 'Podsumowanie wyceny',
      deposit_perc: 'zaliczki',
      summary: 'Podsumowanie',
      viewSummary: 'Zobacz podsumowanie',
      accommodation_included: 'Zakwaterowanie wliczone',
      no_of_adults: 'Liczba dorosłych',
      no_of_children: 'Liczba dzieci',
      no_of_teens: 'Liczba nastolatków',
      no_of_rooms: 'Liczba pokoi',
      arrival_date: 'Data przyjazdu',
      departure_date: 'Data wyjazdu',
      fishing_included: 'Wędkowanie wliczone',
      no_of_anglers: 'Liczba wędkarzy',
      no_of_swims: 'Liczba stanowisk wędkarskich',
      no_of_fishing_days: 'Liczba dni wędkowania',
      fishing_dates: 'Daty wędkowania',
      taxis_included: 'Taksówki wliczone',
      pick_up_date_and_time: 'Data i godzina odbioru',
      pick_up_location: 'Miejsce odbioru',
      drop_off_date_and_time: 'Data i godzina dowozu',
      drop_off_location: 'Miejsce dowozu',
      add_ons: 'Dodatki',
      total_price: 'Cena całkowita',
      pay_today: 'Zapłać dzisiaj',
      your_quote: 'Twoja wycena',
      safe_checkout: 'BEZPIECZNA PŁATNOŚĆ',
      accept_quote: 'AKCEPTUJ WYCEANĘ I REZERWUJ',
      holidayInfoNote:
        'Aby uzyskać szczegółowy podział wszystkiego, co zawiera Twoja wycena, zapoznaj się z naszym pakietem informacyjnym o wakacjach',
      conversion_note:
        ' Proszę pamiętać, że waluta zostanie przeliczona na GBP podczas płatności',
      quote_expired:
        'Twoja wycena wygasła. Proszę skontaktować się z działem rezerwacji.',
      availability_note:
        'Proszę pamiętać, że wyceny są zależne od dostępności w momencie płatności. Proszę szybko dokonać płatności, aby zabezpieczyć wybrane daty.',
      default_description:
        "Dziękujemy za zainteresowanie rezerwacją Exotic Fishing Thailand! Nie możemy się doczekać, aby powitać Cię w ośrodku. Sprawdź szczegóły swojej oferty w sekcji 'Podsumowanie oferty' i gdy będziesz gotowy, kliknij 'Zaakceptuj ofertę i zarezerwuj teraz'. Masz pytania? Skontaktuj się z ",
    },
  },

  sv: {
    reservation: {
      new_reservation: 'Ny bokning',
      packages: 'Paket',
      accommodation: 'Boende',
      fishing: 'Fiske',
      Taxi: 'Taxi',
      add_ons: 'Tillägg',
      guest_details: 'Gästinformation',
      clearSelection: 'Rensa val',
      pleaseSeeYour: 'Vänligen se din',
      quoteBelow: 'Offert nedan',
      packagePrice: 'Paketpris',
      viewPackage: 'Visa paket',
      bookNow: 'Boka nu',
      check_availabilty_book: 'Kontrollera tillgänglighet och boka nu',
      add_reservation_based_on_package:
        'Vill du lägga till en bokning baserat på ett fördefinierat paket?',
      yes: 'Ja',
      no: 'Nej',
      select_package_heading: 'Vänligen välj från tillgängliga paket:',
      no_image: 'Ingen bild',
      last_minute: 'SISTA MINUTEN',
      early_bird: 'TIDIG BOKNING',
      unlimited: 'OBEGRÄNSAD',
      date_range: 'Datumintervall',
      save_continue: 'Spara och fortsätt',
      balancePaid: 'Balans att betala före vistelsen',
      underStandPrice: 'Jag förstår att priset kommer att vara',
      priceQuotedHere:
        'och det angivna priset är en uppskattning baserad på globala valutakurser.',
      finalPriceConfirmation: 'Slutgiltig prisbekräftelse',
      accommodationQuestion: 'Inkluderar denna bokning boende?',
      edit: 'REDIGERA',
      step: 'Steg',
      complete: 'Klart',
      numberOfGuests: 'Antal gäster:',
      adults: 'Vuxen',
      children: 'Barn',
      teen: 'Tonåring',
      numberOfRooms: 'Antal rum:',
      accommodationAvailabilityReminder:
        'VÄNLIGEN ANGE ANTAL GÄSTER OCH RUM FÖR ATT SE TILLGÄNGLIGHET',
      checkIn: 'Incheckning',
      checkInPrefix: 'från',
      checkInSuffix: 'på ankomstdagen',
      checkOut: 'Utcheckning',
      checkOutPrefix: 'till',
      checkOutSuffix: 'på avresedagen',
      saveAndContinue: 'Spara och fortsätt',

      fishingQuestion: 'Inkluderar denna bokning fiske?',
      selectYourLake: 'Välj din sjö',
      noOfAnglers: 'Antal fiskare:',
      noOfSwims: 'Antal fiskeplatser:',
      noOfGuest: 'Gäster som inte fiskar:',
      noOfFishingDays: 'Antal fiskedagar:',
      completeAnglersSwimsDays:
        'Vänligen fyll i antal fiskare, fiskeplatser och fiskedagar för att se tillgänglighet',
      selectYourFishingDates: 'Välj dina fiskedatum:',
      mainLakeTitle: 'Huvudsjön',
      mainLakeDescription:
        'Över hundra fiskar i denna sjö väger över 90 kg, inklusive flera rekordexemplar upp till 90 kg, vilket ger passionerade fiskare en lång lista med mål varje besök – därför återkommer många år efter år.',
      mainLakeAlt: 'Huvudsjön',
      EFTKnowTitle: 'Det du bör veta om fiske på EFT',
      EFTKnowDescription:
        'Huvudsjön är främst reserverad för resortgäster, medan Arapaima-sjön är för dagsutflykter. Fiskare som besöker Thailand och vill ha en unik Arapaima-upplevelse bör seriöst överväga denna sjö!',
      arapaimaLakeDescription1:
        'Vår sjö för dagsutflykter är utformad och fiskad för fiskare som inte har tid att fiska på semestern men ändå vill fånga en Arapaima!',
      arapaimaLakeDescription2:
        'Vi har skapat en sjö som kan ta emot stora kundgrupper genom att introducera ett stort antal Arapaimas.',
      taxiQuestion: 'Inkluderar denna bokning taxi/transfer?',
      addOnsQuestion: 'Inkluderar denna bokning tillägg?',
      taxi: {
        addPickupTaxi: 'Lägg till upphämtningstaxi:',
        pickupDateTime: 'Upphämtningsdatum och tid:',
        pickupLocation: 'Upphämtningsplats:',
        addDropoffTaxi: 'Lägg till lämningstaxi:',
        dropoffDateTime: 'Lämningsdatum och tid:',
        dropoffLocation: 'Lämningsplats:',
        selectTime: 'Välj tid',
        infoNotAvailableTitle: 'Jag har inte denna information än',
        infoNotAvailableNote: '(Oroa dig inte, du kan lägga till det senare!)',
        saveAndContinue: 'Spara och fortsätt',
        yes: 'Ja',
        no: 'Nej',
      },
      cancel: 'Avbryt',
      proceedToPayment: 'Gå till betalning',
      leadGuest: {
        title: 'Detaljer för huvudgästen',
        guestTitle: 'Titel',
        selectTitle: 'Välj titel',
        mr: 'Herr',
        mrs: 'Fru',
        miss: 'Fröken',
        ms: 'Fru',
        dr: 'Dr.',
        nationality: 'Nationalitet',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        email: 'E-post',
        phoneNumber: 'Telefonnummer',
        additionalInformation: 'Ytterligare information',
        declaration:
          'Jag bekräftar att jag har läst och förstått bokningsvillkoren och att all information som lämnats är korrekt.',
        save: 'Spara',
      },
    },
    quote_summary: {
      quote_summary: 'Offertöversikt',
      deposit_perc: 'deposition',
      summary: 'Sammanfattning',
      viewSummary: 'Visa sammanfattning',
      accommodation_included: 'Boende ingår',
      no_of_adults: 'Antal vuxna',
      no_of_children: 'Antal barn',
      no_of_teens: 'Antal tonåringar',
      no_of_rooms: 'Antal rum',
      arrival_date: 'Ankomstdatum',
      departure_date: 'Avresedatum',
      fishing_included: 'Fiske ingår',
      no_of_anglers: 'Antal fiskare',
      no_of_swims: 'Antal fiskeplatser',
      no_of_fishing_days: 'Antal fiskedagar',
      fishing_dates: 'Fiskedatum',
      taxis_included: 'Taxi ingår',
      pick_up_date_and_time: 'Upphämtningsdatum och tid',
      pick_up_location: 'Upphämtningsplats',
      drop_off_date_and_time: 'Lämningsdatum och tid',
      drop_off_location: 'Lämningsplats',
      add_ons: 'Tillägg',
      total_price: 'Totalt pris',
      pay_today: 'Betala idag',
      your_quote: 'Din offert',
      safe_checkout: 'SÄKER UTKASSERING',
      accept_quote: 'ACCEPTERA OFFERT OCH BOKA',
      holidayInfoNote:
        'För en fullständig sammanställning av allt som ingår i din offert, vänligen se vårt semesterinformationspaket',
      conversion_note:
        ' Observera att valutan kommer att konverteras till GBP vid betalningstillfället',
      quote_expired: 'Din offert har gått ut. Vänligen kontakta bokningen.',
      availability_note:
        'Observera att offerter är beroende av tillgänglighet vid betalningstillfället. Betala snabbt för att säkra dina önskade datum.',
      default_description:
        "Tack för ditt intresse av att boka Exotic Fishing Thailand! Vi ser fram emot att välkomna dig till resorten. Kontrollera dina offertuppgifter i avsnittet 'Offertsammanfattning' och klicka på 'Acceptera offert & boka nu' när du är redo att fortsätta. Har du frågor? Vänligen kontakta ",
    },
  },

  fi: {
    reservation: {
      new_reservation: 'Uusi varaus',
      packages: 'Paketit',
      accommodation: 'Majoitus',
      fishing: 'Kalastus',
      Taxi: 'Taksi',
      add_ons: 'Lisäosat',
      guest_details: 'Vieras Tiedot',
      clearSelection: 'Tyhjennä valinta',
      pleaseSeeYour: 'Katso sinun',
      quoteBelow: 'Tarjous alla',
      packagePrice: 'Paketin hinta',
      viewPackage: 'Näytä paketti',
      bookNow: 'Varaa nyt',
      check_availabilty_book: 'Tarkista saatavuus ja varaa nyt',
      add_reservation_based_on_package:
        'Lisää varaus valmiin paketin perusteella?',
      yes: 'Kyllä',
      no: 'Ei',
      select_package_heading: 'Valitse saatavilla olevista paketeista:',
      no_image: 'Ei kuvaa',
      last_minute: 'VIIME HETKEN',
      early_bird: 'AJOISSA VARATTU',
      unlimited: 'RAJATON',
      date_range: 'PÄIVÄMÄÄRÄVÄLI',
      save_continue: 'Tallenna ja jatka',
      balancePaid: 'Loppusumma maksettava ennen oleskelua',
      underStandPrice: 'Ymmärrän, että hinta tulee olemaan',
      priceQuotedHere:
        'ja tässä ilmoitettu hinta on arvio, joka perustuu maailmanlaajuisiin valuuttakursseihin.',
      finalPriceConfirmation: 'Lopullinen hinnan vahvistus',
      accommodationQuestion: 'Sisältääkö varaus yöpymisen?',
      edit: 'MUOKKAA',
      step: 'Vaihe',
      complete: 'Valmis',
      numberOfGuests: 'Vieraiden lukumäärä:',
      adults: 'Aikuinen',
      children: 'Lapsi',
      teen: 'Teini',
      numberOfRooms: 'Huoneiden lukumäärä:',
      accommodationAvailabilityReminder:
        'TÄYTÄ VIERAIDEN JA HUONEIDEN MÄÄRÄ NÄHDÄKSESI SAATAVUUDEN',
      checkIn: 'Sisäänkirjautuminen',
      checkInPrefix: 'alkaen',
      checkInSuffix: 'saapumispäivänä',
      checkOut: 'Uloskirjautuminen',
      checkOutPrefix: 'viimeistään',
      checkOutSuffix: 'lähtöpäivänä',
      saveAndContinue: 'Tallenna ja jatka',

      fishingQuestion: 'Sisältääkö tämä varaus kalastusta?',
      selectYourLake: 'Valitse järvi',
      noOfAnglers: 'Kalastajien määrä:',
      noOfSwims: 'Kalastuspaikkojen määrä:',
      noOfGuest: 'Ei-kalastavat vieraat:',
      noOfFishingDays: 'Kalastuspäivien määrä:',
      completeAnglersSwimsDays:
        'Täytä kalastajien, paikkojen ja päivien määrä nähdäksesi saatavuuden',
      selectYourFishingDates: 'Valitse kalastuspäiväsi:',
      mainLakeTitle: 'Pääjärvi',
      mainLakeDescription:
        'Yli sata kalaa tässä järvessä ylittää 200 lb:n rajan, mukaan lukien useita ennätyskokoisia yksilöitä jopa 200 lb:iin asti, mikä takaa sen, että kovimmatkin kalastajat löytävät täältä haasteensa – ja siksi monet palaavat vuodesta toiseen.',
      mainLakeAlt: 'Pääjärvi',
      EFTKnowTitle: 'Mitä tietää kalastuksesta EFT:ssä',
      EFTKnowDescription:
        'Pääjärvi on pääasiassa lomakeskuksessa majoittuville vieraille, kun taas arapaima-järvi on tarkoitettu päiväretkille. Thaimaassa matkustaville kalastajille tämä järvi tarjoaa unohtumattoman kokemuksen!',
      arapaimaLakeDescription1:
        'Päiväretkijärvi on suunniteltu kiireisille kalastajille, jotka haluavat napata Arapaiman!',
      arapaimaLakeDescription2:
        'Olemme lisänneet runsaasti Arapaimoja, jotta voimme palvella suuria ryhmiä.',
      taxiQuestion: 'Sisältääkö tämä varaus taksin / kuljetukset?',
      addOnsQuestion: 'Sisältääkö tämä varaus lisäosia?',
      taxi: {
        addPickupTaxi: 'Lisää noutotaksi:',
        pickupDateTime: 'Noutopäivämäärä ja aika:',
        pickupLocation: 'Noutopaikka:',
        addDropoffTaxi: 'Lisää palautustaksi:',
        dropoffDateTime: 'Palautuspäivämäärä ja aika:',
        dropoffLocation: 'Palautuspaikka:',
        selectTime: 'Valitse aika',
        infoNotAvailableTitle: 'Tietoa ei ole vielä saatavilla',
        infoNotAvailableNote: '(Ei hätää, voit lisätä sen myöhemmin!)',
        saveAndContinue: 'Tallenna ja jatka',
        yes: 'Kyllä',
        no: 'Ei',
      },
      cancel: 'Peruuta',
      proceedToPayment: 'Siirry maksamaan',
      leadGuest: {
        title: 'Päävieraan tiedot',
        guestTitle: 'Otsikko',
        selectTitle: 'Valitse otsikko',
        mr: 'Herra',
        mrs: 'Rouva',
        miss: 'Neiti',
        ms: 'Neiti (Ms)',
        dr: 'Tohtori',
        nationality: 'Kansalaisuus',
        firstName: 'Etunimi',
        lastName: 'Sukunimi',
        email: 'Sähköposti',
        phoneNumber: 'Puhelinnumero',
        additionalInformation: 'Lisätiedot',
        declaration:
          'Vahvistan lukeneeni ja ymmärtäneeni varausehdot, ja että kaikki annetut tiedot ovat totta ja oikeita.',
        save: 'Tallenna',
      },
    },
    quote_summary: {
      quote_summary: 'Tarjouksen yhteenveto',
      deposit_perc: ' ennakkomaksu',
      summary: 'Yhteenveto',
      viewSummary: 'Näytä yhteenveto',
      accommodation_included: 'Majoitus sisältyy',
      no_of_adults: 'Aikuisten määrä',
      no_of_children: 'Lasten määrä',
      no_of_teens: 'Teinien määrä',
      no_of_rooms: 'Huoneiden määrä',
      arrival_date: 'Saapumispäivä',
      departure_date: 'Lähtöpäivä',
      fishing_included: 'Kalastus sisältyy',
      no_of_anglers: 'Kalastajien määrä',
      no_of_swims: 'Kalastuspaikkojen määrä',
      no_of_fishing_days: 'Kalastuspäivien määrä',
      fishing_dates: 'Kalastuspäivät',
      taxis_included: 'Taksit sisältyvät',
      pick_up_date_and_time: 'Noutopäivämäärä ja aika',
      pick_up_location: 'Noutopaikka',
      drop_off_date_and_time: 'Palautuspäivämäärä ja aika',
      drop_off_location: 'Palautuspaikka',
      add_ons: 'Lisäosat',
      total_price: 'Kokonaishinta',
      pay_today: 'Maksa tänään',
      your_quote: 'sinun tarjouksesi',
      safe_checkout: 'VARMISTETTU TURVALLINEN MAKSU',
      accept_quote: 'HYVÄKSY TARJOUS & VARAA NYT',
      holidayInfoNote:
        'Katso kattava erittely tarjoukseesi sisältyvistä asioista lomatietopaketistamme täältä',
      conversion_note: 'Huom! Valuutta muunnetaan puntiin maksun yhteydessä',
      quote_expired: 'Tarjouksesi on vanhentunut. Ota yhteyttä varauksiin.',
      availability_note:
        'Huomaa, että tarjoukset perustuvat reaaliaikaiseen saatavuuteen. Varmista varauksesi mahdollisimman pian, jotta toivomasi päivät eivät ehdi täyttyä.',
      default_description:
        "Kiitos mielenkiinnostasi varata Exotic Fishing Thailand! Emme malta odottaa toivottaaksemme sinut tervetulleeksi lomakeskukseen. Tarkista tarjoustietosi 'Tarjouksen yhteenveto' -osiossa ja kun olet valmis jatkamaan, napsauta 'Hyväksy tarjous ja varaa nyt'. Kysyttävää? Ota yhteyttä ",
    },
  },
  et: {
    reservation: {
      new_reservation: 'Uus broneering',
      packages: 'Paketid',
      accommodation: 'Majutus',
      fishing: 'Kalapüük',
      Taxi: 'Taksod',
      add_ons: 'Lisad',
      guest_details: 'Külaliste andmed',
      clearSelection: 'Tühjenda valik',
      pleaseSeeYour: 'Palun vaadake oma',
      quoteBelow: 'Pakkumine allpool',
      packagePrice: 'Paketi hind',
      viewPackage: 'Vaata paketti',
      bookNow: 'Broneeri kohe',
      check_availabilty_book: 'Kontrolli saadavust ja broneeri kohe',
      add_reservation_based_on_package:
        'Kas soovite lisada broneeringu eelnevalt määratud paketi alusel?',
      yes: 'Jah',
      no: 'Ei',
      select_package_heading: 'Palun valige saadaolevate pakettide hulgast:',
      no_image: 'Pilt puudub',
      last_minute: 'VIIMANE MINUT',
      early_bird: 'VARAJANE BRONEERING',
      unlimited: 'PIIRAMATU',
      date_range: 'KUUPÄEVA VAHEMIK',
      save_continue: 'Salvesta ja jätka',
      balancePaid: 'Jääk tasuda enne majutust',
      underStandPrice: 'Ma mõistan, et hind on',
      priceQuotedHere:
        'ja siin toodud hind on hinnanguline ülemaailmsete valuutakursside põhjal.',
      finalPriceConfirmation: 'Lõpliku hinna kinnitamine',
      accommodationQuestion: 'Kas broneering sisaldab ööbimist?',
      edit: 'MUUDA',
      step: 'Samm',
      complete: 'Lõpeta',
      numberOfGuests: 'Külaliste arv:',
      adults: 'Täiskasvanud',
      children: 'Lapsed',
      teen: 'Teismeline',
      numberOfRooms: 'Tubade arv:',
      accommodationAvailabilityReminder:
        'MAJUTUSE SAADAVUSE NÄGEMISEKS TÄITKE PALUN KÜLALISTE JA TUBADE ARV',
      checkIn: 'Sisseregistreerimine',
      checkInPrefix: 'alates',
      checkInSuffix: 'saabumise päeval',
      checkOut: 'Väljaregistreerimine',
      checkOutPrefix: 'hiljemalt',
      checkOutSuffix: 'lahkumise päeval',
      saveAndContinue: 'Salvesta ja jätka',
      fishingQuestion: 'Kas see broneering sisaldab kalapüüki?',
      selectYourLake: 'Valige oma järv',
      noOfAnglers: 'Kalameeste arv:',
      noOfSwims: 'Kalastuskohtade arv:',
      noOfGuest: 'Mittekalastavad külalised:',
      noOfFishingDays: 'Kalastuspäevade arv:',
      completeAnglersSwimsDays:
        'Saadavuse nägemiseks täitke kalameeste, kalastuskohtade ja päevade arv',
      selectYourFishingDates: 'Valige oma kalastuspäevad:',
      mainLakeTitle: 'Peajärv',
      mainLakeDescription:
        'Üle saja kala selles järves ületavad 90 kg piiri, sealhulgas mitmed rekordilised isendid kuni 90 kg, pakkudes igale tõsisele kalamehele rohkelt sihtmärke iga külastuse ajal.',
      mainLakeAlt: 'Peajärv',
      EFTKnowTitle: 'Mida teada EFT kalapüügi kohta',
      EFTKnowDescription:
        'Peajärv on mõeldud peamiselt kuurordi külalistele, samas kui arapaima järv on mõeldud päevapiletiga kalastamiseks. Reisis olevad kalamehed peaksid kindlasti kaaluma seda unustamatut kogemust!',
      arapaimaLakeDescription1:
        'Meie päevajärv on mõeldud kalameestele, kes ei saa kogu puhkust kalale pühendada, kuid soovivad siiski püüda arapaima!',
      arapaimaLakeDescription2:
        'Oleme loonud järve, mis suudab teenindada suuri gruppe, lisades palju arapaima kalu.',
      taxiQuestion: 'Kas broneering sisaldab taksot/transfeeri?',
      addOnsQuestion: 'Kas broneering sisaldab lisasid?',
      taxi: {
        addPickupTaxi: 'Lisa pealevõtu takso:',
        pickupDateTime: 'Pealevõtu kuupäev ja kellaaeg:',
        pickupLocation: 'Pealevõtu asukoht:',
        addDropoffTaxi: 'Lisa äraviimise takso:',
        dropoffDateTime: 'Äraviimise kuupäev ja kellaaeg:',
        dropoffLocation: 'Äraviimise asukoht:',
        selectTime: 'Vali kellaaeg',
        infoNotAvailableTitle: 'Mul ei ole seda teavet veel',
        infoNotAvailableNote: '(Ärge muretsege, saab hiljem lisada!)',
        saveAndContinue: 'Salvesta ja jätka',
        yes: 'Jah',
        no: 'Ei',
      },
      cancel: 'Tühista',
      proceedToPayment: 'Jätka maksele',
      leadGuest: {
        title: 'Peamise külalise andmed',
        guestTitle: 'Tiitel',
        selectTitle: 'Vali tiitel',
        mr: 'Hr',
        mrs: 'Pr',
        miss: 'Preili',
        ms: 'Prl',
        dr: 'Dr',
        nationality: 'Rahvus',
        firstName: 'Eesnimi',
        lastName: 'Perekonnanimi',
        email: 'E-post',
        phoneNumber: 'Telefoninumber',
        additionalInformation: 'Lisainformatsioon',
        declaration:
          'Kinnitan, et olen lugenud ja aru saanud broneeringu tingimustest ning kogu esitatud teave on tõene ja täpne.',
        save: 'Salvesta',
      },
    },
    quote_summary: {
      quote_summary: 'Hinnapakkumise kokkuvõte',
      deposit_perc: 'ettemaks',
      summary: 'Kokkuvõte',
      viewSummary: 'Vaata kokkuvõtet',
      accommodation_included: 'Majutus kaasas',
      no_of_adults: 'Täiskasvanute arv',
      no_of_children: 'Laste arv',
      no_of_teens: 'Teismeliste arv',
      no_of_rooms: 'Tubade arv',
      arrival_date: 'Saabumiskuupäev',
      departure_date: 'Lahkumiskuupäev',
      fishing_included: 'Kalapüük kaasas',
      no_of_anglers: 'Kalameeste arv',
      no_of_swims: 'Kalastuskohtade arv',
      no_of_fishing_days: 'Kalastuspäevade arv',
      fishing_dates: 'Kalastuspäevad',
      taxis_included: 'Taksod kaasas',
      pick_up_date_and_time: 'Pealevõtu kuupäev ja aeg',
      pick_up_location: 'Pealevõtu asukoht',
      drop_off_date_and_time: 'Äraviimise kuupäev ja aeg',
      drop_off_location: 'Äraviimise asukoht',
      add_ons: 'Lisad',
      total_price: 'Koguhind',
      pay_today: 'Maksa täna',
      your_quote: 'teie pakkumine',
      safe_checkout: 'TURVALINE MAKSIMINE',
      accept_quote: 'NÕUSTU PAKKUMISEGA JA BRONEERI',
      holidayInfoNote:
        'Kõige, mis sisaldub teie hinnapakkumises, üksikasjalikuks jaotuseks vaadake meie puhkuseinfopaketti',
      conversion_note:
        'Pange tähele, et maksmisel konverteeritakse valuuta naelsterlingiks (GBP)',
      quote_expired:
        'Teie pakkumine on aegunud. Palun võtke ühendust broneeringute osakonnaga.',
      availability_note:
        'Pange tähele, et pakkumised sõltuvad reaalajas saadavusest maksmise hetkel. Palun maksa ja kinnita broneering võimalikult kiiresti, et vältida soovitud kuupäevade kättesaamatuks muutumist.',
      default_description:
        "Täname huvi tundmast Exotic Fishing Thailandi broneerimise vastu! Me ei jõua ära oodata, et sind kuurordis tervitada. Palun kontrolli oma pakkumise andmeid jaotisest 'Pakkumise kokkuvõte' ning kui oled valmis, klõpsa 'Nõustu pakkumisega ja broneeri kohe'. Küsimusi? Võta ühendust ",
    },
  },
  de: {
    reservation: {
      new_reservation: 'Neue Reservierung',
      packages: 'Pakete',
      accommodation: 'Unterkunft',
      fishing: 'Angeln',
      Taxi: 'Taxi',
      add_ons: 'Extras',
      guest_details: 'Gastdetails',
      clearSelection: 'Auswahl löschen',
      pleaseSeeYour: 'Bitte sehen Sie Ihre',
      quoteBelow: 'Angebot unten',
      packagePrice: 'Paketpreis',
      viewPackage: 'Paket anzeigen',
      bookNow: 'Jetzt buchen',
      check_availabilty_book: 'Verfügbarkeit prüfen & jetzt buchen',
      add_reservation_based_on_package:
        'Reservierung basierend auf einem vordefinierten Paket hinzufügen?',
      yes: 'Ja',
      no: 'Nein',
      select_package_heading: 'Bitte wählen Sie aus den verfügbaren Paketen:',
      no_image: 'Kein Bild',
      last_minute: 'LAST MINUTE',
      early_bird: 'FRÜHBUCHER',
      unlimited: 'UNBEGRENZT',
      date_range: 'Datumsbereich',
      save_continue: 'Speichern und fortfahren',

      accommodationQuestion: 'Beinhaltet diese Reservierung Unterkunft?',
      edit: 'BEARBEITEN',
      step: 'Schritt',
      complete: 'Abgeschlossen',
      numberOfGuests: 'Anzahl der Gäste:',
      adults: 'Erwachsener',
      children: 'Kind',
      teen: 'Jugendlicher',
      numberOfRooms: 'Anzahl der Zimmer:',
      accommodationAvailabilityReminder:
        'BITTE GEBEN SIE DIE ANZAHL DER GÄSTE UND ZIMMER EIN, UM DIE VERFÜGBARKEIT ZU SEHEN',
      checkIn: 'Check-in',
      checkInPrefix: 'ab',
      checkInSuffix: 'am Ankunftstag',
      checkOut: 'Check-out',
      checkOutPrefix: 'vor',
      checkOutSuffix: 'am Abreisetag',
      saveAndContinue: 'Speichern und fortfahren',
      balancePaid: 'Restbetrag vor dem Aufenthalt zu zahlen',
      underStandPrice: 'Ich verstehe, dass der Preis',
      priceQuotedHere:
        'und der hier angegebene Preis ist eine ungefähre Angabe basierend auf globalen Wechselkursen.',
      finalPriceConfirmation: 'Endgültige Preisbestätigung',
      fishingQuestion: 'Beinhaltet diese Reservierung Angeln?',
      selectYourLake: 'Wählen Sie Ihren See',
      noOfAnglers: 'Anzahl der Angler:',
      noOfSwims: 'Anzahl der Angelplätze:',
      noOfGuest: 'Nicht angelnde Gäste:',
      noOfFishingDays: 'Anzahl der Angeltage:',
      completeAnglersSwimsDays:
        'Bitte vervollständigen Sie die Anzahl der Angler, Angelplätze und Angeltage, um die Verfügbarkeit zu sehen',
      selectYourFishingDates: 'Wählen Sie Ihre Angeldaten:',
      mainLakeTitle: 'Der Hauptsee',
      mainLakeDescription:
        'Über hundert Fische in diesem See wiegen über 90 kg, darunter mehrere Rekordexemplare bis zu 90 kg, was selbst für leidenschaftliche Angler eine lange Liste von Zielen bei jedem Besuch garantiert – daher kehren viele Jahr für Jahr zurück.',
      mainLakeAlt: 'Hauptsee',
      EFTKnowTitle: 'Was Sie über Angeln bei EFT wissen sollten',
      EFTKnowDescription:
        'Der Hauptsee ist hauptsächlich für Gäste des Resorts reserviert, während der Arapaima-See für Tagesausflüge vorbereitet ist. Angler, die Thailand besuchen und ein einzigartiges Arapaima-Erlebnis wünschen, sollten diesen See ernsthaft in Betracht ziehen!',
      arapaimaLakeDescription1:
        'Unser See für Tagesausflüge ist für Angler konzipiert und bestückt, die während ihres Urlaubs keine Zeit zum Angeln haben, aber dennoch einen Arapaima fangen möchten!',
      arapaimaLakeDescription2:
        'Wir haben einen See geschaffen, der große Kundengruppen aufnehmen kann, indem wir eine große Anzahl von Arapaimas eingeführt haben.',
      taxiQuestion: 'Beinhaltet diese Reservierung Taxis / Transfers?',
      addOnsQuestion: 'Beinhaltet diese Reservierung Extras?',
      taxi: {
        addPickupTaxi: 'Abholungstaxi hinzufügen:',
        pickupDateTime: 'Abholdatum und -zeit:',
        pickupLocation: 'Abholort:',
        addDropoffTaxi: 'Taxi für Rückfahrt hinzufügen:',
        dropoffDateTime: 'Rückfahrtsdatum und -zeit:',
        dropoffLocation: 'Rückfahrtsort:',
        selectTime: 'Zeit auswählen',
        infoNotAvailableTitle: 'Ich habe diese Information noch nicht',
        infoNotAvailableNote:
          '(Keine Sorge, Sie können sie später hinzufügen!)',
        saveAndContinue: 'Speichern und fortfahren',
        yes: 'Ja',
        no: 'Nein',
      },
      cancel: 'Abbrechen',
      proceedToPayment: 'Zur Zahlung',
      leadGuest: {
        title: 'Details des Hauptgastes',
        guestTitle: 'Anrede',
        selectTitle: 'Bitte Anrede wählen',
        mr: 'Herr',
        mrs: 'Frau',
        miss: 'Fräulein',
        ms: 'Frau',
        dr: 'Dr.',
        nationality: 'Nationalität',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phoneNumber: 'Telefonnummer',
        additionalInformation: 'Zusätzliche Informationen',
        declaration:
          'Ich bestätige, dass ich die Buchungsbedingungen gelesen und verstanden habe und dass alle gemachten Angaben korrekt sind.',
        save: 'Speichern',
      },
    },
    quote_summary: {
      quote_summary: 'Angebotsübersicht',
      deposit_perc: 'Anzahlung',
      summary: 'Zusammenfassung',
      viewSummary: 'Zusammenfassung anzeigen',
      accommodation_included: 'Unterkunft enthalten',
      no_of_adults: 'Anzahl Erwachsener',
      no_of_children: 'Anzahl Kinder',
      no_of_teens: 'Anzahl Jugendlicher',
      no_of_rooms: 'Anzahl Zimmer',
      arrival_date: 'Anreisedatum',
      departure_date: 'Abreisedatum',
      fishing_included: 'Angeln enthalten',
      no_of_anglers: 'Anzahl Angler',
      no_of_swims: 'Anzahl Angelplätze',
      no_of_fishing_days: 'Anzahl Angeltage',
      fishing_dates: 'Angeltermine',
      taxis_included: 'Taxis enthalten',
      pick_up_date_and_time: 'Abholdatum und -zeit',
      pick_up_location: 'Abholort',
      drop_off_date_and_time: 'Rückgabedatum und -zeit',
      drop_off_location: 'Rückgabeort',
      add_ons: 'Extras',
      total_price: 'Gesamtpreis',
      pay_today: 'Heute zahlen',
      your_quote: 'Ihr Angebot',
      safe_checkout: 'SICHERER CHECKOUT',
      accept_quote: 'ANGEBOT ANNEHMEN UND BUCHEN',
      holidayInfoNote:
        'Für eine vollständige Übersicht über alles, was in Ihrem Angebot enthalten ist, sehen Sie sich bitte unser Urlaubsinformationspaket ',

      conversion_note:
        ' Bitte beachten Sie, dass die Währung zum Zeitpunkt der Zahlung in GBP umgerechnet wird',
      quote_expired:
        'Ihr Angebot ist abgelaufen. Bitte wenden Sie sich an die Buchungsabteilung.',
      availability_note:
        'Bitte beachten Sie, dass Angebote zum Zeitpunkt der Zahlung von der Verfügbarkeit abhängen. Bitte zahlen Sie schnell, um Ihre gewünschten Termine zu sichern.',
      default_description:
        "Vielen Dank für Ihr Interesse an einer Buchung bei Exotic Fishing Thailand! Wir freuen uns darauf, Sie im Resort begrüßen zu dürfen. Bitte überprüfen Sie Ihre Angebotsdetails im Abschnitt 'Angebotsübersicht' und klicken Sie auf 'Angebot annehmen & jetzt buchen', wenn Sie bereit sind fortzufahren. Fragen? Bitte kontaktieren Sie ",
    },
  },

  zh: {
    reservation: {
      new_reservation: '新预订',
      packages: '套餐',
      accommodation: '住宿',
      fishing: '钓鱼',
      Taxi: '出租车',
      add_ons: '附加项目',
      guest_details: '客人信息',
      clearSelection: '清除选择',
      pleaseSeeYour: '请查看您的',
      quoteBelow: '报价如下',
      packagePrice: '套餐价格',
      viewPackage: '查看套餐',
      bookNow: '立即预订',
      check_availabilty_book: '查看可用性并立即预订',
      add_reservation_based_on_package: '是否根据预设套餐添加预订？',
      yes: '是',
      no: '否',
      select_package_heading: '请选择可用套餐：',
      no_image: '无图片',
      last_minute: '最后时刻',
      early_bird: '提前预订',
      unlimited: '无限',
      date_range: '日期范围',
      save_continue: '保存并继续',
      balancePaid: '在住宿前需支付余额',
      underStandPrice: '我理解价格将是',
      priceQuotedHere: '此处所列价格是根据全球汇率预估的。',
      finalPriceConfirmation: '最终价格确认',
      accommodationQuestion: '预订是否包含过夜住宿？',
      edit: '编辑',
      step: '步骤',
      complete: '完成',
      numberOfGuests: '客人数：',
      adults: '成人',
      children: '儿童',
      teen: '青少年',
      numberOfRooms: '房间数：',
      accommodationAvailabilityReminder:
        '请填写客人数量和所需房间数以查看可用性',
      checkIn: '入住时间',
      checkInPrefix: '从',
      checkInSuffix: '抵达日当天起',
      checkOut: '退房时间',
      checkOutPrefix: '至',
      checkOutSuffix: '离开日当天止',
      saveAndContinue: '保存并继续',

      fishingQuestion: '此预订是否包括钓鱼？',
      selectYourLake: '选择您的湖泊',
      noOfAnglers: '钓鱼人数：',
      noOfSwims: '钓位数量：',
      noOfGuest: '非钓鱼客人：',
      noOfFishingDays: '钓鱼天数：',
      completeAnglersSwimsDays: '请填写钓鱼人数、钓位和钓鱼天数以查看可用性',
      selectYourFishingDates: '选择您的钓鱼日期：',
      mainLakeTitle: '主湖',
      mainLakeDescription:
        '湖中有超过一百条超过90公斤的鱼，包括多条创纪录的鱼类，确保每次访问都充满挑战和目标，这也是为何那么多钓客年复一年地回来。',
      mainLakeAlt: '主湖',
      EFTKnowTitle: '关于在EFT钓鱼需要了解的事项',
      EFTKnowDescription:
        '主湖主要为度假村客人开放，而巨骨舌鱼湖则为一日钓客而设。来泰国旅游且希望捕捉巨骨舌鱼的钓客应认真考虑此湖！',
      arapaimaLakeDescription1:
        '我们的一日钓鱼湖专为那些假期中时间有限、但又希望钓到巨骨舌鱼的钓客而设。',
      arapaimaLakeDescription2:
        '我们通过引入大量巨骨舌鱼，打造了一个可接待大型团体的钓鱼湖。',
      taxiQuestion: '此预订是否包含出租车/接送服务？',
      addOnsQuestion: '此预订是否包含附加项目？',
      taxi: {
        addPickupTaxi: '添加接车服务：',
        pickupDateTime: '接车日期与时间：',
        pickupLocation: '接车地点：',
        addDropoffTaxi: '添加送车服务：',
        dropoffDateTime: '送达日期与时间：',
        dropoffLocation: '送达地点：',
        selectTime: '选择时间',
        infoNotAvailableTitle: '我暂时没有这些信息',
        infoNotAvailableNote: '（别担心，可以稍后添加！）',
        saveAndContinue: '保存并继续',
        yes: '是',
        no: '否',
      },
      cancel: '取消',
      proceedToPayment: '前往付款',
      leadGuest: {
        title: '主客人信息',
        guestTitle: '称谓',
        selectTitle: '选择称谓',
        mr: '先生',
        mrs: '女士',
        miss: '小姐',
        ms: '女士',
        dr: '博士',
        nationality: '国籍',
        firstName: '名字',
        lastName: '姓氏',
        email: '电子邮件',
        phoneNumber: '电话号码',
        additionalInformation: '附加信息',
        declaration: '我确认我已阅读并理解预订条款，且所提供信息真实准确。',
        save: '保存',
      },
    },
    quote_summary: {
      quote_summary: '报价摘要',
      deposit_perc: '定金',
      summary: '摘要',
      viewSummary: '查看摘要',
      accommodation_included: '包含住宿',
      no_of_adults: '成人人数',
      no_of_children: '儿童人数',
      no_of_teens: '青少年人数',
      no_of_rooms: '房间数',
      arrival_date: '到达日期',
      departure_date: '离开日期',
      fishing_included: '包含钓鱼',
      no_of_anglers: '钓鱼人数',
      no_of_swims: '钓位数量',
      no_of_fishing_days: '钓鱼天数',
      fishing_dates: '钓鱼日期',
      taxis_included: '包含出租车',
      pick_up_date_and_time: '接车日期和时间',
      pick_up_location: '接车地点',
      drop_off_date_and_time: '送达日期和时间',
      drop_off_location: '送达地点',
      add_ons: '附加项目',
      total_price: '总价',
      pay_today: '今日支付',
      your_quote: '您的报价',
      safe_checkout: '安全验证结账',
      accept_quote: '接受报价并立即预订',
      holidayInfoNote:
        '有关报价中包含内容的详细信息，请在此处查看我们的度假信息包',
      conversion_note: '请注意，结账时货币将转换为英镑',
      quote_expired: '您的报价已过期。请联系预订部门。',
      availability_note:
        '请注意，报价以结账时的实时可用性为准。请尽快付款以确保所选日期可用。',
      default_description:
        '感谢您有意预订 Exotic Fishing Thailand！我们迫不及待地欢迎您来到度假村。请在“报价摘要”部分验证您的报价详情，准备好后点击“接受报价并立即预订”。有任何问题？请联系 ',
    },
  },

  'en-SG': {
    reservation: {
      new_reservation: 'New Reservation',
      packages: 'Packages',
      accommodation: 'Accommodation',
      fishing: 'Fishing',
      Taxi: 'Taxi',
      add_ons: 'Add-Ons',
      guest_details: 'Guest Details',
      clearSelection: 'Clear Selection',
      pleaseSeeYour: 'Please see your',
      quoteBelow: 'Quote Below',
      packagePrice: 'Package Price',
      viewPackage: 'View Package',
      bookNow: 'Book Now',
      check_availabilty_book: 'Check availability & book now',
      add_reservation_based_on_package:
        'Add reservation based on a preset package?',
      yes: 'Yes',
      no: 'No',
      select_package_heading: 'Please select from the available packages:',
      no_image: 'No Image',
      last_minute: 'LAST MINUTE',
      early_bird: 'EARLY BIRD',
      unlimited: 'UNLIMITED',
      date_range: 'DATE RANGE',
      save_continue: 'Save & Continue',
      balancePaid: 'Balance to be paid prior to stay',
      underStandPrice: 'I understand that the price will be',
      priceQuotedHere:
        'and the price quoted here is an approximation based on global currency exchange rates.',
      finalPriceConfirmation: 'Final Price Confirmation',
      accommodationQuestion: 'Does the reservation include an overnight stay?',
      edit: 'EDIT',
      step: 'Step',
      complete: 'Complete',
      numberOfGuests: 'No. Of Guests:',
      adults: 'Adult',
      children: 'Child',
      teen: 'Teen',
      numberOfRooms: 'No. Of Rooms:',
      accommodationAvailabilityReminder:
        'PLEASE COMPLETE THE NO. OF GUESTS AND ROOMS REQUIRED TO SEE AVAILABILITY',
      checkIn: 'Check-in',
      checkInPrefix: 'is from',
      checkInSuffix: 'on day of arrival',
      checkOut: 'Check-out',
      checkOutPrefix: 'is by',
      checkOutSuffix: 'on day of departure',
      saveAndContinue: 'Save & Continue',

      fishingQuestion: 'Does this reservation include fishing?',
      selectYourLake: 'Select your lake',
      noOfAnglers: 'No. Of Anglers:',
      noOfSwims: 'No. Of swims:',
      noOfGuest: 'Non-Angling Guests:',
      noOfFishingDays: 'No. Of fishing days:',
      completeAnglersSwimsDays:
        'Please complete the no. of anglers, swims and fishing days to see availability',
      selectYourFishingDates: 'Select Your Fishing Dates:',
      mainLakeTitle: 'The Main Lake',
      mainLakeDescription:
        'More than a hundred of the fish in this lake are in excess of the 200lb mark, including a number of record-size specimens up to 200lb, ensuring that even the most die-hard of Specimen Hunters has a long list of targets to consider during each and every visit to us, which is why so many of our anglers return year on year.',
      mainLakeAlt: 'Main Lake',
      EFTKnowTitle: 'Things to know about fishing at EFT',
      EFTKnowDescription:
        'The Main Lake is predominantly for guests staying at the resort, while the arapaima lake has been setup for day ticket trips. Anglers travelling through Thailand that want an unforgettable experience targeting Arapaima should seriously consider this lake!',
      arapaimaLakeDescription1:
        ' Our Day Trip Lake is designed and stocked for fishermen who do not have the time to spend their holiday fishing due to other commitments but they do want to catch an Arapaima!',
      arapaimaLakeDescription2:
        'We have created a lake that can cater for large groups of customers by introducing a large number of Arapaima.',
      taxiQuestion: 'Does this reservation include taxi’s / transfers?',
      addOnsQuestion: 'Does this reservation include add-ons?',
      taxi: {
        addPickupTaxi: 'Add Pickup Taxi:',
        pickupDateTime: 'Pickup Date & Time:',
        pickupLocation: 'Pickup Location:',
        addDropoffTaxi: 'Add Dropoff Taxi:',
        dropoffDateTime: 'Dropoff Date & Time:',
        dropoffLocation: 'Dropoff Location:',
        selectTime: 'Select time',
        infoNotAvailableTitle: 'I don’t have this information yet',
        infoNotAvailableNote: '(Don’t worry, it can be added later!)',
        saveAndContinue: 'Save & Continue',
        yes: 'Yes',
        no: 'No',
      },
      cancel: 'Cancel',
      proceedToPayment: 'Proceed to Payment',
      leadGuest: {
        title: 'Lead Guest Details',
        guestTitle: 'Title',
        selectTitle: 'Select Title',
        mr: 'Mr',
        mrs: 'Mrs',
        miss: 'Miss',
        ms: 'Ms',
        dr: 'Dr',
        nationality: 'Nationality',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phoneNumber: 'Phone Number',
        additionalInformation: 'Additional Information',
        declaration:
          'I confirm that I have read and understood the terms and conditions of booking and that all info provided is true and accurate.',
        save: 'Save',
      },
    },
    quote_summary: {
      quote_summary: 'Quote Summary',
      deposit_perc: 'Deposit',
      summary: 'Summary',
      viewSummary: 'View Summary',
      accommodation_included: 'Accommodation Included',
      no_of_adults: 'No. Of Adults',
      no_of_children: 'No. Of Children',
      no_of_teens: 'No. Of Teens',
      no_of_rooms: 'No. Of Rooms',
      arrival_date: 'Arrival Date',
      departure_date: 'Departure Date',
      fishing_included: 'Fishing Included',
      no_of_anglers: 'No. Of Anglers',
      no_of_swims: 'No. Of Swims',
      no_of_fishing_days: 'No. Of Fishing Days',
      fishing_dates: 'Fishing Dates',
      taxis_included: "Taxi's Included",
      pick_up_date_and_time: 'Pickup Date And Time',
      pick_up_location: 'Pickup Location',
      drop_off_date_and_time: 'Dropoff Date And Time',
      drop_off_location: 'Dropoff Location',
      add_ons: 'Add-ons',
      total_price: 'Total Price',
      pay_today: 'Pay Today',
      your_quote: 'your quote',
      safe_checkout: 'VERIFIED SAFE CHECKOUT',
      accept_quote: 'ACCEPT QUOTE & BOOK NOW',
      holidayInfoNote:
        'For a comprehensive breakdown of everything included in your quote, please check out our holiday information pack',
      conversion_note:
        ' Please note currency will be converted to GBP at checkout',
      quote_expired: 'Your quote has expired. Please contact reservations.',
      availability_note:
        'Please note that quotes are subject to live availability at the time of checkout. Please pay and secure your booking as soon as possible to avoid your requested dates becoming unavailable.',
      default_description:
        "Thank you for showing interest in booking Exotic Fishing Thailand! We can't wait to welcome you to the resort. Please verify your quote details on the 'Quote Summary' section and when ready to proceed, please click 'Accept Quote & Book Now'. Any questions? Please contact ",
    },
  },
  da: {
    reservation: {
      new_reservation: 'Ny reservation',
      packages: 'Pakker',
      accommodation: 'Indkvartering',
      fishing: 'Fiskeri',
      Taxi: 'Taxi',
      add_ons: 'Ekstra tilvalg',
      guest_details: 'Gæsteoplysninger',
      clearSelection: 'Ryd valg',
      pleaseSeeYour: 'Se venligst din',
      quoteBelow: 'Tilbud nedenfor',
      packagePrice: 'Pakkepris',
      viewPackage: 'Se pakke',
      bookNow: 'Book nu',
      check_availabilty_book: 'Tjek tilgængelighed og book nu',
      add_reservation_based_on_package:
        'Tilføj reservation baseret på en forudindstillet pakke?',
      yes: 'Ja',
      no: 'Nej',
      select_package_heading: 'Vælg venligst mellem de tilgængelige pakker:',
      no_image: 'Intet billede',
      last_minute: 'SIDSTE ØJEBLIK',
      early_bird: 'EARLY BIRD',
      unlimited: 'UBEGRÆNSET',
      date_range: 'DATOINTERVAL',
      save_continue: 'Gem & Fortsæt',
      balancePaid: 'Restbeløb skal betales før opholdet',
      underStandPrice: 'Jeg forstår, at prisen vil være',
      priceQuotedHere:
        'og prisen angivet her er en omtrentlig vurdering baseret på globale valutakurser.',
      finalPriceConfirmation: 'Endelig prisbekræftelse',
      accommodationQuestion: 'Indeholder reservationen en overnatning?',
      edit: 'REDIGER',
      step: 'Trin',
      complete: 'Færdig',
      numberOfGuests: 'Antal gæster:',
      adults: 'Voksen',
      children: 'Barn',
      teen: 'Teenager',
      numberOfRooms: 'Antal værelser:',
      accommodationAvailabilityReminder:
        'UDFYLD VENLIGST ANTAL GÆSTER OG VÆRELSER FOR AT SE TILGÆNGELIGHED',
      checkIn: 'Check-in',
      checkInPrefix: 'er fra',
      checkInSuffix: 'på ankomstdagen',
      checkOut: 'Check-out',
      checkOutPrefix: 'er senest',
      checkOutSuffix: 'på afrejsedagen',
      saveAndContinue: 'Gem & Fortsæt',

      fishingQuestion: 'Indeholder denne reservation fiskeri?',
      selectYourLake: 'Vælg din sø',
      noOfAnglers: 'Antal lystfiskere:',
      noOfSwims: 'Antal fiskepladser:',
      noOfGuest: 'Gæster uden fiskeri:',
      noOfFishingDays: 'Antal fiskedage:',
      completeAnglersSwimsDays:
        'Udfyld venligst antal lystfiskere, fiskepladser og fiskedage for at se tilgængelighed',
      selectYourFishingDates: 'Vælg dine fiskedatoer:',
      mainLakeTitle: 'Hovedsøen',
      mainLakeDescription:
        'Mere end hundrede af fiskene i denne sø vejer over 90 kg, inklusive rekordstore eksemplarer. Det sikrer, at selv de mest dedikerede lystfiskere har mange mål at forfølge under hvert besøg – hvilket er grunden til, at mange vender tilbage år efter år.',
      mainLakeAlt: 'Hovedsø',
      EFTKnowTitle: 'Værd at vide om fiskeri hos EFT',
      EFTKnowDescription:
        'Hovedsøen er primært for gæster, der bor på resortet, mens arapaima-søen er beregnet til dagsture. Lystfiskere, der rejser gennem Thailand og ønsker en uforglemmelig oplevelse, bør overveje denne sø!',
      arapaimaLakeDescription1:
        ' Vores dagstur-sø er designet og fyldt til lystfiskere, som ikke har tid til længere ophold, men som stadig ønsker at fange en Arapaima!',
      arapaimaLakeDescription2:
        'Vi har skabt en sø med mange Arapaimaer, der kan rumme store grupper.',
      taxiQuestion: 'Indeholder denne reservation taxa/transport?',
      addOnsQuestion: 'Indeholder denne reservation ekstra tilvalg?',
      taxi: {
        addPickupTaxi: 'Tilføj afhentningstaxa:',
        pickupDateTime: 'Afhentningsdato og -tid:',
        pickupLocation: 'Afhentningssted:',
        addDropoffTaxi: 'Tilføj afleveringstaxa:',
        dropoffDateTime: 'Afleveringsdato og -tid:',
        dropoffLocation: 'Afleveringssted:',
        selectTime: 'Vælg tidspunkt',
        infoNotAvailableTitle: 'Jeg har ikke disse oplysninger endnu',
        infoNotAvailableNote: '(Bare rolig, det kan tilføjes senere!)',
        saveAndContinue: 'Gem & Fortsæt',
        yes: 'Ja',
        no: 'Nej',
      },
      cancel: 'Annuller',
      proceedToPayment: 'Fortsæt til betaling',
      leadGuest: {
        title: 'Oplysninger om hovedgæst',
        guestTitle: 'Titel',
        selectTitle: 'Vælg titel',
        mr: 'Hr.',
        mrs: 'Fr.',
        miss: 'Frk.',
        ms: 'Ms',
        dr: 'Dr.',
        nationality: 'Nationalitet',
        firstName: 'Fornavn',
        lastName: 'Efternavn',
        email: 'Email',
        phoneNumber: 'Telefonnummer',
        additionalInformation: 'Yderligere oplysninger',
        declaration:
          'Jeg bekræfter, at jeg har læst og forstået vilkår og betingelser, og at alle oplysninger er korrekte.',
        save: 'Gem',
      },
    },
    quote_summary: {
      quote_summary: 'Tilbudsoversigt',
      deposit_perc: 'Depositum',
      summary: 'Oversigt',
      viewSummary: 'Se oversigt',
      accommodation_included: 'Indkvartering inkluderet',
      no_of_adults: 'Antal voksne',
      no_of_children: 'Antal børn',
      no_of_teens: 'Antal teenagere',
      no_of_rooms: 'Antal værelser',
      arrival_date: 'Ankomstdato',
      departure_date: 'Afrejsedato',
      fishing_included: 'Fiskeri inkluderet',
      no_of_anglers: 'Antal lystfiskere',
      no_of_swims: 'Antal fiskepladser',
      no_of_fishing_days: 'Antal fiskedage',
      fishing_dates: 'Fiskedatoer',
      taxis_included: 'Taxa inkluderet',
      pick_up_date_and_time: 'Afhentningsdato og -tid',
      pick_up_location: 'Afhentningssted',
      drop_off_date_and_time: 'Afleveringsdato og -tid',
      drop_off_location: 'Afleveringssted',
      add_ons: 'Ekstra tilvalg',
      total_price: 'Totalpris',
      pay_today: 'Betal i dag',
      your_quote: 'dit tilbud',
      safe_checkout: 'BEKRÆFTET SIKKER BETALING',
      accept_quote: 'ACCEPTÉR TILBUD & BOOK NU',
      holidayInfoNote:
        'For en omfattende oversigt over alt, der er inkluderet i dit tilbud, se venligst vores feriepakkemateriale',
      conversion_note: ' Bemærk: valuta konverteres til GBP ved betaling',
      quote_expired: 'Dit tilbud er udløbet. Kontakt venligst reservationen.',
      availability_note:
        'Tilbud er afhængige af ledige datoer ved betaling. Betal venligst hurtigt for at sikre dine ønskede datoer.',
      default_description:
        "Tak for din interesse i at booke Exotic Fishing Thailand! Vi glæder os til at byde dig velkommen til resortet. Bekræft venligst dine tilbudsoplysninger i afsnittet 'Tilbudsoversigt', og når du er klar, klik på 'Accepter tilbud & book nu'. Spørgsmål? Kontakt venligst ",
    },
  },
  ro: {
    reservation: {
      new_reservation: 'Rezervare nouă',
      packages: 'Pachete',
      accommodation: 'Cazare',
      fishing: 'Pescuit',
      Taxi: 'Taxi',
      add_ons: 'Adăugiri',
      guest_details: 'Detalii oaspete',
      clearSelection: 'Șterge selecția',
      pleaseSeeYour: 'Vă rugăm să consultați',
      quoteBelow: 'Ofertă mai jos',
      packagePrice: 'Preț pachet',
      viewPackage: 'Vezi pachet',
      bookNow: 'Rezervă acum',
      check_availabilty_book: 'Verifică disponibilitatea și rezervă acum',
      add_reservation_based_on_package:
        'Adăugați rezervare pe baza unui pachet prestabilit?',
      yes: 'Da',
      no: 'Nu',
      select_package_heading:
        'Vă rugăm să selectați din pachetele disponibile:',
      no_image: 'Fără imagine',
      last_minute: 'ULTIMUL MOMENT',
      early_bird: 'REZERVARE TIMPURIE',
      unlimited: 'NELIMITAT',
      date_range: 'PERIOADĂ',
      save_continue: 'Salvează și continuă',
      balancePaid: 'Suma rămasă de plată înainte de ședere',
      underStandPrice: 'Înțeleg că prețul va fi',
      priceQuotedHere:
        'și prețul indicat aici este o aproximare bazată pe cursurile valutare globale.',
      finalPriceConfirmation: 'Confirmarea prețului final',
      accommodationQuestion: 'Include rezervarea o cazare peste noapte?',
      edit: 'EDITEAZĂ',
      step: 'Pas',
      complete: 'Complet',
      numberOfGuests: 'Nr. de oaspeți:',
      adults: 'Adult',
      children: 'Copil',
      teen: 'Adolescent',
      numberOfRooms: 'Nr. de camere:',
      accommodationAvailabilityReminder:
        'VĂ RUGĂM COMPLETAȚI NR. DE OASPEȚI ȘI CAMERE PENTRU A VEDEA DISPONIBILITATEA',
      checkIn: 'Check-in',
      checkInPrefix: 'începând cu',
      checkInSuffix: 'în ziua sosirii',
      checkOut: 'Check-out',
      checkOutPrefix: 'până la',
      checkOutSuffix: 'în ziua plecării',
      saveAndContinue: 'Salvează și continuă',

      fishingQuestion: 'Include această rezervare pescuit?',
      selectYourLake: 'Selectează lacul',
      noOfAnglers: 'Nr. de pescari:',
      noOfSwims: 'Nr. de posturi de pescuit:',
      noOfGuest: 'Oaspeți care nu pescuiesc:',
      noOfFishingDays: 'Nr. de zile de pescuit:',
      completeAnglersSwimsDays:
        'Vă rugăm să completați nr. de pescari, posturi de pescuit și zile de pescuit pentru a vedea disponibilitatea',
      selectYourFishingDates: 'Selectați datele de pescuit:',
      mainLakeTitle: 'Lacul Principal',
      mainLakeDescription:
        'Peste o sută de pești din acest lac depășesc 90 kg, inclusiv exemplare record de până la 200 kg, oferind pescarilor dedicați o listă lungă de ținte de urmărit – motiv pentru care mulți dintre ei revin an de an.',
      mainLakeAlt: 'Lacul Principal',
      EFTKnowTitle: 'Lucruri de știut despre pescuitul la EFT',
      EFTKnowDescription:
        'Lacul Principal este destinat în principal oaspeților cazați în resort, în timp ce lacul arapaima este destinat excursiilor de o zi. Pescarii care vizitează Thailanda și vor o experiență de neuitat ar trebui să ia în considerare acest lac!',
      arapaimaLakeDescription1:
        ' Lacul nostru pentru excursii de o zi este conceput pentru pescarii care nu pot petrece o vacanță întreagă pescuind, dar care doresc totuși să prindă un Arapaima!',
      arapaimaLakeDescription2:
        'Am creat un lac care poate găzdui grupuri mari prin introducerea unui număr mare de Arapaima.',
      taxiQuestion: 'Include această rezervare taxi / transferuri?',
      addOnsQuestion: 'Include această rezervare servicii adiționale?',
      taxi: {
        addPickupTaxi: 'Adaugă taxi pentru preluare:',
        pickupDateTime: 'Data și ora preluării:',
        pickupLocation: 'Locul preluării:',
        addDropoffTaxi: 'Adaugă taxi pentru predare:',
        dropoffDateTime: 'Data și ora predării:',
        dropoffLocation: 'Locul predării:',
        selectTime: 'Selectează ora',
        infoNotAvailableTitle: 'Nu am încă aceste informații',
        infoNotAvailableNote: '(Nu-ți face griji, pot fi adăugate mai târziu!)',
        saveAndContinue: 'Salvează și continuă',
        yes: 'Da',
        no: 'Nu',
      },
      cancel: 'Anulează',
      proceedToPayment: 'Continuă la plată',
      leadGuest: {
        title: 'Detalii oaspete principal',
        guestTitle: 'Titlu',
        selectTitle: 'Selectează titlul',
        mr: 'Dl.',
        mrs: 'Dna.',
        miss: 'Domnișoară',
        ms: 'Dna.',
        dr: 'Dr.',
        nationality: 'Naționalitate',
        firstName: 'Prenume',
        lastName: 'Nume de familie',
        email: 'Email',
        phoneNumber: 'Număr de telefon',
        additionalInformation: 'Informații suplimentare',
        declaration:
          'Confirm că am citit și înțeles termenii și condițiile rezervării și că toate informațiile furnizate sunt corecte.',
        save: 'Salvează',
      },
    },
    quote_summary: {
      quote_summary: 'Sumar ofertă',
      deposit_perc: 'Avans',
      summary: 'Rezumat',
      viewSummary: 'Vezi rezumatul',
      accommodation_included: 'Cazare inclusă',
      no_of_adults: 'Nr. de adulți',
      no_of_children: 'Nr. de copii',
      no_of_teens: 'Nr. de adolescenți',
      no_of_rooms: 'Nr. de camere',
      arrival_date: 'Data sosirii',
      departure_date: 'Data plecării',
      fishing_included: 'Pescuit inclus',
      no_of_anglers: 'Nr. de pescari',
      no_of_swims: 'Nr. de posturi de pescuit',
      no_of_fishing_days: 'Nr. de zile de pescuit',
      fishing_dates: 'Date de pescuit',
      taxis_included: 'Taxi inclus',
      pick_up_date_and_time: 'Data și ora preluării',
      pick_up_location: 'Locul preluării',
      drop_off_date_and_time: 'Data și ora predării',
      drop_off_location: 'Locul predării',
      add_ons: 'Adăugiri',
      total_price: 'Preț total',
      pay_today: 'Plătește astăzi',
      your_quote: 'oferta ta',
      safe_checkout: 'PLATĂ SIGURĂ VERIFICATĂ',
      accept_quote: 'ACCEPTĂ OFERTA ȘI REZERVĂ ACUM',
      holidayInfoNote:
        'Pentru o detaliere completă a tot ceea ce este inclus în oferta dumneavoastră, vă rugăm să consultați pachetul nostru informativ de vacanță',

      conversion_note:
        ' Rețineți că valuta va fi convertită în GBP la finalizarea comenzii',
      quote_expired: 'Oferta a expirat. Contactați echipa de rezervări.',
      availability_note:
        'Vă rugăm rețineți că ofertele depind de disponibilitatea în timp real. Plătiți cât mai curând pentru a vă asigura datele dorite.',
      default_description:
        "Vă mulțumim pentru interesul acordat rezervării la Exotic Fishing Thailand! Abia așteptăm să vă întâmpinăm la complex. Vă rugăm să verificați detaliile ofertei dvs. în secțiunea 'Sumar Ofertă', iar când sunteți pregătit, faceți clic pe 'Acceptați Oferta și Rezervați Acum'. Întrebări? Vă rugăm să contactați ",
    },
  },
  nl: {
    reservation: {
      new_reservation: 'Nieuwe reservering',
      packages: 'Pakketten',
      accommodation: 'Accommodatie',
      fishing: 'Vissen',
      Taxi: 'Taxi',
      add_ons: "Extra's",
      guest_details: 'Gasteninformatie',
      packagePrice: 'Pakketprijs',
      viewPackage: 'Bekijk pakket',
      bookNow: 'Boek nu',
      check_availabilty_book: 'Controleer beschikbaarheid en boek nu',
      add_reservation_based_on_package:
        'Reservering maken op basis van een vooraf ingesteld pakket?',
      yes: 'Ja',
      no: 'Nee',
      select_package_heading: 'Selecteer uit de beschikbare pakketten:',
      no_image: 'Geen afbeelding',
      last_minute: 'LAST MINUTE',
      early_bird: 'VROEGBOEK',
      unlimited: 'ONBEPERKT',
      date_range: 'DATUMBEREIK',
      save_continue: 'Opslaan en doorgaan',
      balancePaid: 'Saldo te betalen vóór het verblijf',
      underStandPrice: 'Ik begrijp dat de prijs zal zijn',
      priceQuotedHere:
        'en de hier vermelde prijs is een schatting op basis van wereldwijde wisselkoersen.',
      finalPriceConfirmation: 'Bevestiging van de definitieve prijs',
      accommodationQuestion: 'Bevat de reservering een overnachting?',
      edit: 'BEWERKEN',
      step: 'Stap',
      complete: 'Voltooid',
      numberOfGuests: 'Aantal gasten:',
      adults: 'Volwassene',
      children: 'Kind',
      teen: 'Tiener',
      numberOfRooms: 'Aantal kamers:',
      accommodationAvailabilityReminder:
        'VUL HET AANTAL GASTEN EN KAMERS IN OM BESCHIKBAARHEID TE ZIEN',
      checkIn: 'Inchecken',
      checkInPrefix: 'is vanaf',
      checkInSuffix: 'op de aankomstdag',
      checkOut: 'Uitchecken',
      checkOutPrefix: 'is uiterlijk om',
      checkOutSuffix: 'op de vertrekdag',
      saveAndContinue: 'Opslaan en doorgaan',
      clearSelection: 'Selectie wissen',
      pleaseSeeYour: 'Bekijk uw',
      quoteBelow: 'Offerte hieronder',

      fishingQuestion: 'Bevat deze reservering vissen?',
      selectYourLake: 'Selecteer uw meer',
      noOfAnglers: 'Aantal vissers:',
      noOfSwims: 'Aantal visplekken:',
      noOfGuest: 'Niet-visgasten:',
      noOfFishingDays: 'Aantal visdagen:',
      completeAnglersSwimsDays:
        'Vul het aantal vissers, visplekken en visdagen in om beschikbaarheid te zien',
      selectYourFishingDates: 'Selecteer uw visdata:',
      mainLakeTitle: 'Het hoofdmeer',
      mainLakeDescription:
        'Meer dan honderd vissen in dit meer zijn zwaarder dan 90 kg, inclusief een aantal recordexemplaren tot 90 kg, wat betekent dat zelfs de meest fanatieke sportvisser een lange lijst aan doelen heeft. Daarom keren zoveel vissers elk jaar terug.',
      mainLakeAlt: 'Hoofdmeer',
      EFTKnowTitle: 'Wat u moet weten over vissen bij EFT',
      EFTKnowDescription:
        'Het hoofdmeer is voornamelijk bedoeld voor gasten die in het resort verblijven, terwijl het arapaima-meer bedoeld is voor dagpassen. Vissers die door Thailand reizen en een onvergetelijke ervaring willen met het vissen op Arapaima, moeten dit meer zeker overwegen!',
      arapaimaLakeDescription1:
        'Ons dagtochtmeer is ontworpen en gevuld voor vissers die geen tijd hebben om hun vakantie door te brengen met vissen, maar toch een Arapaima willen vangen!',
      arapaimaLakeDescription2:
        'We hebben een meer gecreëerd dat geschikt is voor grote groepen klanten door een groot aantal Arapaima toe te voegen.',

      taxiQuestion: "Bevat deze reservering taxi's / transfers?",
      addOnsQuestion: "Bevat deze reservering extra's?",
      taxi: {
        addPickupTaxi: 'Ophaaltaxi toevoegen:',
        pickupDateTime: 'Ophaaldatum & tijd:',
        pickupLocation: 'Ophaallocatie:',
        addDropoffTaxi: 'Afgifttaxi toevoegen:',
        dropoffDateTime: 'Afgiftdatum & tijd:',
        dropoffLocation: 'Afgiftelocatie:',
        selectTime: 'Selecteer tijd',
        infoNotAvailableTitle: 'Ik heb deze informatie nog niet',
        infoNotAvailableNote: '(Geen zorgen, dit kan later worden toegevoegd!)',
        saveAndContinue: 'Opslaan en doorgaan',
        yes: 'Ja',
        no: 'Nee',
      },
      cancel: 'Annuleren',
      proceedToPayment: 'Doorgaan naar betaling',
      leadGuest: {
        title: 'Hoofdgastgegevens',
        guestTitle: 'Aanspreektitel',
        selectTitle: 'Selecteer titel',
        mr: 'Dhr.',
        mrs: 'Mevr.',
        miss: 'Mej.',
        ms: 'Mevr.',
        dr: 'Dr.',
        nationality: 'Nationaliteit',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        email: 'E-mail',
        phoneNumber: 'Telefoonnummer',
        additionalInformation: 'Aanvullende informatie',
        declaration:
          'Ik bevestig dat ik de boekingsvoorwaarden heb gelezen en begrepen en dat alle verstrekte informatie juist is.',
        save: 'Opslaan',
      },
    },
    quote_summary: {
      quote_summary: 'Offerteoverzicht',
      deposit_perc: 'Aanbetaling',
      summary: 'Overzicht',
      viewSummary: 'Bekijk samenvatting',
      accommodation_included: 'Accommodatie inbegrepen',
      no_of_adults: 'Aantal volwassenen',
      no_of_children: 'Aantal kinderen',
      no_of_teens: 'Aantal tieners',
      no_of_rooms: 'Aantal kamers',
      arrival_date: 'Aankomstdatum',
      departure_date: 'Vertrekdatum',
      fishing_included: 'Vissen inbegrepen',
      no_of_anglers: 'Aantal vissers',
      no_of_swims: 'Aantal visplekken',
      no_of_fishing_days: 'Aantal visdagen',
      fishing_dates: 'Visdata',
      taxis_included: 'Taxi inbegrepen',
      pick_up_date_and_time: 'Ophaaldatum en -tijd',
      pick_up_location: 'Ophaallocatie',
      drop_off_date_and_time: 'Afgiftdatum en -tijd',
      drop_off_location: 'Afgiftelocatie',
      add_ons: "Extra's",
      total_price: 'Totale prijs',
      pay_today: 'Betaal vandaag',
      your_quote: 'uw offerte',
      safe_checkout: 'VEILIGE CHECKOUT GEGARANDEERD',
      accept_quote: 'ACCEPTEER OFFERTE & BOEK NU',
      holidayInfoNote:
        'Voor een volledig overzicht van alles wat in uw offerte is opgenomen, bekijk hier ons informatiepakket voor vakanties',
      conversion_note:
        'Houd er rekening mee dat de valuta wordt omgerekend naar GBP bij het afrekenen',
      quote_expired:
        'Uw offerte is verlopen. Neem contact op met reserveringen.',
      availability_note:
        'Let op: offertes zijn afhankelijk van live beschikbaarheid tijdens het afrekenen. Betaal zo snel mogelijk om uw gewenste data veilig te stellen.',
      default_description:
        "Bedankt voor je interesse in het boeken van Exotic Fishing Thailand! We kunnen niet wachten om je te verwelkomen op het resort. Controleer je offertegegevens in het gedeelte 'Offertesamenvatting' en klik op 'Accepteer offerte & boek nu' wanneer je klaar bent om verder te gaan. Vragen? Neem contact op met ",
    },
  },
};

export { languageTranslation };
